<template>
    <v-app>
        <mainMenu></mainMenu>
        <v-container>
            <v-card>
                <!-- แสดงปุ่มการค้นหา -->
                <v-card-title>
                    <!-- <font color="orange darken-4">ใบขนส่งสินค้า</font> -->
                    <!-- ปุ่มต่าง ๆ -->
                    <template>
                        <v-hover v-slot:default="{ hover }">
                            <v-btn :color="hover ? 'orange accent-4' : null" text @click="showDialogFindManageCar">
                                <v-icon>mdi-folder-search</v-icon>
                                 ค้นหาเลขที่ใบจัดรถ
                            </v-btn>
                        </v-hover>
                        <v-hover v-slot:default="{ hover }">
                            <v-btn :color="hover ? 'orange accent-4' : null" text @click="showDialogFindSO">
                                <v-icon>mdi-folder-search</v-icon>
                                 ค้นหาเลขที่ SO
                            </v-btn>
                        </v-hover>
                        <v-hover v-slot:default="{ hover }">
                            <v-btn :color="hover ? 'orange accent-4' : null" text @click="showDialogFindRT">
                                <v-icon>mdi-folder-search</v-icon>
                                 ค้นหาเลขที่ RT
                            </v-btn>
                        </v-hover>
                        <v-spacer></v-spacer>
                        <v-hover v-slot:default="{ hover }" v-if="soList.length > 0 || rtList.length > 0">
                            <v-btn :color="hover ? 'orange accent-4' : null" text @click="printDelivery">
                                <v-icon>mdi-printer</v-icon>
                                 พิมพ์ใบขนส่งสินค้า
                            </v-btn>
                        </v-hover>
                    </template>

                    <!-- แสดงหน้าการค้นหาเลขที่ใบจัดส่ง -->
                    <v-dialog v-model="dialogFindManageCar" persistent max-width="400">
                        <v-card>
                            <br>
                            <v-card-text>
                                <v-layout justify-center>
                                    <v-flex xs4>
                                        <v-text-field v-model="findNoManageCar" label="เลขที่:" ref="findNoManageCar" color="orange accent-3" 
                                        @keypress.enter="findManageCar"></v-text-field>
                                    </v-flex>
                                    <v-flex mt-2 xs1>
                                        <v-btn fab small color="orange accent-4" @click="findManageCar">
                                            <v-icon color="white">mdi-magnify</v-icon>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex v-if="hideBtnDel" mt-2 xs1 ml-4>
                                        <v-btn fab small color="blue-grey darken-1" @click="editInfoManageCar">
                                            <v-icon color="white">mdi-file-document-edit</v-icon>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex v-if="hideBtnDel" mt-2 xs1 ml-4>
                                        <v-btn fab small color="light-green darken-3" @click="printDelivery">
                                            <v-icon color="white">mdi-printer</v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>

                                <!-- แสดงหน้าต่างแก้ไขใบจัดส่ง -->
                                <v-dialog v-model="dialogEditInfoManageCar" persistent max-width="800">
                                    <v-card>
                                        <v-card-text>
                                            <br>
                                            <v-layout wrap>
                                                <v-flex lg2 mr-2>
                                                    <v-text-field v-model="mc.transNo" label="เลขที่:" 
                                                    ref="mc.transNo" color="orange accent-3" readonly></v-text-field>
                                                </v-flex>
                                                <v-flex lg2 mr-2>
                                                    <v-menu v-model="mc.menuLoadDate" :close-on-content-click="false" 
                                                    :nudge-right="40" transition="scale-transition"
                                                    offset-y min-width="290px">
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field v-model="mc.loadDate" label="วันที่ขึ้นของ:" v-on="on" 
                                                            color="orange accent-3" readonly></v-text-field>
                                                        </template>
                                                        <v-date-picker v-model="mc.loadDate" @input="mc.menuLoadDate = false" 
                                                        color="orange accent-3" :min="nowDate" @change="dateTransNo"></v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                                <v-flex lg2 mr-2>
                                                    <v-menu v-model="mc.menuDeliDate" :close-on-content-click="false" 
                                                    :nudge-right="40" transition="scale-transition"
                                                    offset-y min-width="290px">
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field v-model="mc.delDate" label="วันที่ส่งของ:" v-on="on" 
                                                            color="orange accent-3" readonly></v-text-field>
                                                        </template>
                                                        <v-date-picker v-model="mc.delDate" @input="mc.menuDeliDate = false" 
                                                        color="orange accent-3" :min="mc.loadDate"></v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                                <v-flex lg3 mr-2>
                                                    <v-autocomplete :items="driverItem" item-color="orange accent-3"
                                                    color="orange accent-3" v-model="mc.driver" label="ชื่อคนขับรถ:"></v-autocomplete>
                                                </v-flex>
                                                <v-flex lg2>
                                                    <v-autocomplete :items="regNumItem" item-color="orange accent-3"
                                                    color="orange accent-3" v-model="mc.regNum" label="ทะเบียน"></v-autocomplete>
                                                </v-flex>
                                            </v-layout>
                                            <v-divider></v-divider>
                                            <br>
                                            <v-layout>
                                                <v-flex text-right mr-2>
                                                    <v-btn @click="confiEditInfoManageCar" text color="green">ตกลง</v-btn>
                                                </v-flex>
                                                <v-flex text-left>
                                                    <v-btn @click="dialogEditInfoManageCar = false" text color="red">ยกเลิก</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                    </v-card>
                                </v-dialog>

                                <template v-if="showArrSOAndRT">
                                    <v-divider></v-divider>
                                    <br>
                                    <v-layout>
                                        <v-flex><strong>วันที่ขึ้นของ: {{find.loadDate}}</strong></v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex><strong>วันที่ส่งของ: {{find.delDate}}</strong></v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex><strong>คนขับรถ: {{find.driver}}</strong></v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex><strong>เลขทะเบียน: {{find.regNum}}</strong></v-flex>
                                    </v-layout>
                                    <br>

                                    <!-- รายการ SO -->
                                    <v-divider></v-divider>
                                    <v-data-table :headers="headerFindSO" :items="arrSO" :items-per-page="100" 
                                    hide-default-footer dense class="elevation-1" sort-by="time">
                                        <template v-slot:no-data>
                                            <v-flex>
                                                <strong><font color="red">ไม่พบข้อมูล</font></strong>
                                            </v-flex>
                                        </template>
                                        <template v-slot:item.action="{ item }">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-hover v-slot:default="{ hover }">
                                                        <v-icon :color="hover ? 'orange accent-4' : null" 
                                                        @click="editFindSO(item)" 
                                                        v-on="on">mdi-history</v-icon>
                                                    </v-hover>
                                                </template>
                                                <span>เปลี่ยนเวลาส่ง</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-hover v-slot:default="{ hover }">
                                                        <v-icon :color="hover ? 'red' : null" 
                                                        @click="delSo(item)" v-on="on">mdi-delete</v-icon>
                                                    </v-hover>
                                                </template>
                                                <span>ลบ SO</span>
                                            </v-tooltip>
                                        </template>
                                    </v-data-table>
                                    <br>

                                    <!-- หน้าเปลี่ยนแปลงเวลาจัดส่ง SO -->
                                    <v-dialog v-model="dialogChangeCarTimeSO" persistent max-width="250">
                                        <v-card>
                                            <br>
                                            <v-card-text>
                                                <v-layout>
                                                    <v-flex mr-2>
                                                        <v-text-field v-model="time.st" label="เริ่มส่งเวลา:" v-mask="'##:##'" suffix="น." 
                                                        color="orange accent-3" ref="st"></v-text-field>
                                                    </v-flex>
                                                    <v-flex>
                                                        <v-text-field v-model="time.end" label="สิ้นสุดส่งเวลา:" v-mask="'##:##'" suffix="น." 
                                                        color="orange accent-3" ref="end"></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-divider></v-divider>
                                                <br>
                                                <v-layout>
                                                    <v-flex text-right mr-2>
                                                        <v-btn @click="confiChangeCarTimeSO" text color="green">ตกลง</v-btn>
                                                    </v-flex>
                                                    <v-flex text-left>
                                                        <v-btn @click="dialogChangeCarTimeSO = false" text color="red">ยกเลิก</v-btn>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-text>
                                        </v-card>
                                    </v-dialog>

                                    <!-- รายการ RT -->
                                    <v-divider></v-divider>
                                    <v-data-table :headers="headerFindRT" :items="arrRT" :items-per-page="100" 
                                    hide-default-footer dense class="elevation-1" sort-by="time">
                                        <template v-slot:no-data>
                                            <v-flex>
                                                <strong><font color="red">ไม่พบข้อมูล</font></strong>
                                            </v-flex>
                                        </template>
                                        <template v-slot:item.action="{ item }">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-hover v-slot:default="{ hover }">
                                                        <v-icon :color="hover ? 'orange accent-4' : null" 
                                                        @click="editFindRT(item)" 
                                                        v-on="on">mdi-history</v-icon>
                                                    </v-hover>
                                                </template>
                                                <span>เปลี่ยนเวลาส่ง</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-hover v-slot:default="{ hover }">
                                                        <v-icon :color="hover ? 'red' : null" 
                                                        @click="delRt(item)" v-on="on">mdi-delete</v-icon>
                                                    </v-hover>
                                                </template>
                                                <span>ลบ RT</span>
                                            </v-tooltip>
                                        </template>
                                    </v-data-table>
                                    <br>

                                    <!-- หน้าเปลี่ยนแปลงเวลาจัดส่ง RT -->
                                    <v-dialog v-model="dialogChangeCarTimeRT" persistent max-width="250">
                                        <v-card>
                                            <br>
                                            <v-card-text>
                                                <v-layout>
                                                    <v-flex mr-2>
                                                        <v-text-field v-model="time.st" label="เริ่มส่งเวลา:" v-mask="'##:##'" suffix="น." 
                                                        color="orange accent-3" ref="st"></v-text-field>
                                                    </v-flex>
                                                    <v-flex>
                                                        <v-text-field v-model="time.end" label="สิ้นสุดส่งเวลา:" v-mask="'##:##'" suffix="น." 
                                                        color="orange accent-3" ref="end"></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-divider></v-divider>
                                                <br>
                                                <v-layout>
                                                    <v-flex text-right mr-2>
                                                        <v-btn @click="confiChangeCarTimeRT" text color="green">ตกลง</v-btn>
                                                    </v-flex>
                                                    <v-flex text-left>
                                                        <v-btn @click="dialogChangeCarTimeRT = false" text color="red">ยกเลิก</v-btn>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-text>
                                        </v-card>
                                    </v-dialog>
                                </template>
                                <v-divider></v-divider>
                                <br>
                                <v-layout>
                                    <v-flex text-center>
                                        <v-btn text @click="closeFind">ปิด</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-dialog>

                    <!-- แสดงหน้าการค้นหาเลขที่ SO -->
                    <v-dialog v-model="dialogFindSO" persistent max-width="400">
                        <v-card>
                            <br>
                            <v-card-text>
                                <v-layout justify-center>
                                    <v-flex xs6>
                                        <v-text-field v-model="findNoSO" label="เลขที่ SO:" ref="findNoSO" color="orange accent-3" 
                                        @keypress.enter="findManageSO" :rules="rulesFindSO" counter="9"></v-text-field>
                                    </v-flex>
                                    <v-flex mt-2 xs1>
                                        <v-btn fab small color="orange accent-4" @click="findManageSO">
                                            <v-icon color="white">mdi-magnify</v-icon>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex v-if="hideBtnDel" mt-2 xs1 ml-4>
                                        <v-btn fab small color="red" @click="delfindSO">
                                            <v-icon color="white">mdi-delete</v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <template v-if="showArrSOAndRT">
                                    <v-divider></v-divider>
                                    <br>
                                    <v-layout>
                                        <v-flex><strong>เลขที่ใบขนส่งสินค้า: {{find.transNo}}</strong></v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex><strong>วันที่ขึ้นของ: {{find.loadDate}}</strong></v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex><strong>วันที่ส่งของ: {{find.delDate}}</strong></v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex><strong>คนขับรถ: {{find.driver}}</strong></v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex><strong>เลขทะเบียน: {{find.regNum}}</strong></v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <strong>เวลาส่ง: {{find.time}} <template v-if="find.time">น. </template></strong>
                                            <v-tooltip right>
                                                <template v-slot:activator="{ on }">
                                                    <v-hover v-slot:default="{ hover }">
                                                        <v-icon :color="hover ? 'orange accent-4' : null" @click="ChangeTimeSO" 
                                                        v-on="on">mdi-history</v-icon>
                                                    </v-hover>
                                                </template>
                                                <span>เปลี่ยนเวลาส่ง</span>
                                            </v-tooltip>
                                        </v-flex>
                                    </v-layout>
                                    <br>
                                </template>
                                <v-divider></v-divider>
                                <br>
                                <v-layout>
                                    <v-flex text-center>
                                        <v-btn text @click="closeFind">ปิด</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>

                        <!-- หน้าเปลี่ยนแปลงเวลาจัดส่ง SO -->
                        <v-dialog v-model="dialogChangeTimeSO" persistent max-width="250">
                            <v-card>
                                <br>
                                <v-card-text>
                                    <v-layout>
                                        <v-flex mr-2>
                                            <v-text-field v-model="time.st" label="เริ่มส่งเวลา:" v-mask="'##:##'" suffix="น." 
                                            color="orange accent-3" ref="st"></v-text-field>
                                        </v-flex>
                                        <v-flex>
                                            <v-text-field v-model="time.end" label="สิ้นสุดส่งเวลา:" v-mask="'##:##'" suffix="น." 
                                            color="orange accent-3" ref="end"></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-divider></v-divider>
                                    <br>
                                    <v-layout>
                                        <v-flex text-right mr-2>
                                            <v-btn @click="confiChangeTimeSO" text color="green">ตกลง</v-btn>
                                        </v-flex>
                                        <v-flex text-left>
                                            <v-btn @click="dialogChangeTimeSO = false" text color="red">ยกเลิก</v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </v-dialog>
                    </v-dialog>

                    <!-- แสดงหน้าการค้นหาเลขที่ RT -->
                    <v-dialog v-model="dialogFindRT" persistent max-width="400">
                        <v-card>
                            <br>
                            <v-card-text>
                                <v-layout justify-center>
                                    <v-flex xs6>
                                        <v-text-field v-model="findNoRT" label="เลขที่ RT:" ref="findNoRT" color="orange accent-3" 
                                        @keypress.enter="findManageRT" :rules="rulesFindRT" counter="9"></v-text-field>
                                    </v-flex>
                                    <v-flex mt-2 xs1>
                                        <v-btn fab small color="orange accent-4" @click="findManageRT">
                                            <v-icon color="white">mdi-magnify</v-icon>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex v-if="hideBtnDel" mt-2 xs1 ml-4>
                                        <v-btn fab small color="red" @click="delfindRT">
                                            <v-icon color="white">mdi-delete</v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <template v-if="showArrSOAndRT">
                                    <v-divider></v-divider>
                                    <br>
                                    <v-layout>
                                        <v-flex><strong>เลขที่ใบขนส่งสินค้า: {{find.transNo}}</strong></v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex><strong>วันที่ขึ้นของ: {{find.loadDate}}</strong></v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex><strong>วันที่ส่งของ: {{find.delDate}}</strong></v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex><strong>คนขับรถ: {{find.driver}}</strong></v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex><strong>เลขทะเบียน: {{find.regNum}}</strong></v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <strong>เวลาส่ง: {{find.time}} <template v-if="find.time">น. </template></strong>
                                            <v-tooltip right>
                                                <template v-slot:activator="{ on }">
                                                    <v-hover v-slot:default="{ hover }">
                                                        <v-icon :color="hover ? 'orange accent-4' : null" @click="ChangeTimeRT" 
                                                        v-on="on">mdi-history</v-icon>
                                                    </v-hover>
                                                </template>
                                                <span>เปลี่ยนเวลาส่ง</span>
                                            </v-tooltip>
                                        </v-flex>
                                    </v-layout>
                                    <br>
                                </template>
                                <v-divider></v-divider>
                                <br>
                                <v-layout>
                                    <v-flex text-center>
                                        <v-btn text @click="closeFind">ปิด</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>

                        <!-- หน้าเปลี่ยนแปลงเวลาจัดส่ง RT -->
                        <v-dialog v-model="dialogChangeTimeRT" persistent max-width="250">
                            <v-card>
                                <br>
                                <v-card-text>
                                    <v-layout>
                                        <v-flex mr-2>
                                            <v-text-field v-model="time.st" label="เริ่มส่งเวลา:" v-mask="'##:##'" suffix="น." 
                                            color="orange accent-3" ref="st"></v-text-field>
                                        </v-flex>
                                        <v-flex>
                                            <v-text-field v-model="time.end" label="สิ้นสุดส่งเวลา:" v-mask="'##:##'" suffix="น." 
                                            color="orange accent-3" ref="end"></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-divider></v-divider>
                                    <br>
                                    <v-layout>
                                        <v-flex text-right mr-2>
                                            <v-btn @click="confiChangeTimeRT" text color="green">ตกลง</v-btn>
                                        </v-flex>
                                        <v-flex text-left>
                                            <v-btn @click="dialogChangeTimeRT = false" text color="red">ยกเลิก</v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </v-dialog>
                    </v-dialog>

                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <!-- เลขที่, วันที่ขึ้นของ และ วันที่ส่งของ -->
                    <v-layout wrap>
                        <v-flex>
                            <v-layout wrap>
                                <v-flex lg3 md5 sm3 xs4>
                                    <v-text-field v-model="transNo" label="เลขที่:" ref="transNo"
                                    color="orange accent-3" @keypress.enter="getTransNo" 
                                    :readonly="soList.length > 0 || rtList.length > 0"></v-text-field>
                                </v-flex>
                                <v-flex mt-2>
                                    <v-btn style="margin: 0px 5px 0px 0px" fab small @click="getTransNo" color="orange accent-4"
                                    :disabled="soList.length > 0 || rtList.length > 0">
                                    <v-icon color="white">mdi-magnify</v-icon></v-btn>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn fab small color="orange accent-4" v-on="on" @click="clearPage">
                                                <v-icon color="white">mdi-cached</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>ล้างค่า</span>
                                    </v-tooltip>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex>
                            <v-layout justify-end>
                                <v-flex lg3 md4 sm4 xs6>
                                    <v-menu v-model="menuLoadDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                                    offset-y min-width="290px" :disabled="soList.length > 0 || rtList.length > 0">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="loadDate" label="วันที่ขึ้นของ:" prepend-icon="mdi-calendar" v-on="on" 
                                            color="orange accent-3" readonly></v-text-field>
                                        </template>
                                        <v-date-picker v-model="loadDate" @input="menuLoadDate = false" color="orange accent-3"
                                        :readonly="soList.length > 0 || rtList.length > 0" :min="nowDate" @change="dateManageCar"></v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <v-flex lg3 md4 sm4 xs6>
                                    <v-menu v-model="menuDeliDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                                    offset-y min-width="290px" :disabled="soList.length > 0 || rtList.length > 0">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="deliDate" label="วันที่ส่งของ:" prepend-icon="mdi-calendar" v-on="on" 
                                            color="orange accent-3" readonly></v-text-field>
                                        </template>
                                        <v-date-picker v-model="deliDate" @input="menuDeliDate = false" color="orange accent-3"
                                        :readonly="soList.length > 0 || rtList.length > 0" :min="loadDate"></v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>

                    <!-- รายละเอียดคนขับรถ และ ทะเบียนรถ -->
                    <v-layout justify-end wrap>
                        <v-flex lg3 md4 sm4 xs12 mr-2>
                            <v-select :items="driverItem" v-model="driver" label="ชื่อคนขับรถ:" color="orange accent-3" 
                            item-color="orange accent-3" ref="driver" :readonly="soList.length > 0 || rtList.length > 0"></v-select>
                            <!-- <v-autocomplete :items="driverItem" v-model="driver" label="ชื่อคนขับรถ:" color="orange accent-3" 
                            item-color="orange accent-3" ref="driver" :readonly="soList.length > 0 || rtList.length > 0"></v-autocomplete> -->
                        </v-flex>
                        <v-flex lg2 md3 sm2 xs12>
                            <v-select :items="regNumItem" v-model="regNum" label="เลขทะเบียน:" color="orange accent-3"
                            item-color="orange accent-3" ref="regNum" :readonly="soList.length > 0 || rtList.length > 0"></v-select>
                            <!-- <v-autocomplete :items="regNumItem" v-model="regNum" label="เลขทะเบียน:" color="orange accent-3"
                            item-color="orange accent-3" ref="regNum" :readonly="soList.length > 0 || rtList.length > 0"></v-autocomplete> -->
                        </v-flex>
                    </v-layout>

                    <!-- text-field ค้นหาเลขที่ SO และ RT -->
                    <v-layout wrap>
                        <v-flex lg3 md3 sm4 xs8>
                            <v-text-field v-model="searchSo" label="เลขที่ SO:" ref="searchSo" color="orange accent-3" 
                            @keypress.enter="getSo" counter="9" :rules="rulesSo" required></v-text-field>
                        </v-flex>
                        <v-flex mt-2>
                            <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                    <v-btn fab small color="orange accent-4" v-on="on" @click="getSo">
                                        <v-icon color="white">mdi-file-document-box-search-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>ค้นหาเลขที่ SO</span>
                            </v-tooltip>
                        </v-flex>
                        <v-flex lg3 md3 sm4 xs8>
                            <v-text-field v-model="searchRT" label="เลขที่ RT:" ref="searchRT" color="orange accent-3" 
                            @keypress.enter="getRT" counter="9" :rules="rulesRt" required></v-text-field>
                        </v-flex>
                        <v-flex mt-2>
                            <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                    <v-btn fab small color="orange accent-4" v-on="on" @click="getRT">
                                        <v-icon color="white">mdi-file-document-box-search-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>ค้นหาเลขที่ RT</span>
                            </v-tooltip>
                        </v-flex>

                        <!-- เพิ่มข้อมูลใน SO ด้วย showNewSO-->
                        <v-dialog v-model="showNewSo" persistent>
                            <v-card>
                                <v-card-text>
                                    <br>
                                    <!-- ส่วนหัว -->
                                    <v-layout wrap>
                                        <v-flex lg2 md2 sm3 xs9 mr-2>
                                            <v-text-field v-model="cardCode" color="orange accent-3" label="รหัสร้านค้า" readonly></v-text-field>
                                        </v-flex>
                                        <v-flex lg4 md5 sm5 xs12 v-if="cardPhone.length > 1">
                                            <v-text-field v-model="cardPhone" color="orange accent-3" label="โทรศัพท์" readonly></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex lg6 md8 sm9 xs12>
                                            <v-text-field v-model="cardName" color="orange accent-3" label="ชื่อร้านค้า" readonly></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <!-- แสดงรายการสินค้าที่ต้องส่ง -->
                                    <v-card>
                                        <v-card-text v-if="showCust">
                                            <v-layout wrap>
                                                <v-flex lg4 md6 sm7 xs12 mr-2>
                                                    <v-text-field v-model="custName" color="orange accent-3" label="ชื่อลูกค้า" readonly></v-text-field>
                                                </v-flex>
                                                <v-flex lg3 md4 sm4 xs12 mr-2>
                                                    <v-text-field v-model="custTel" color="orange accent-3" label="โทรศัพท์" readonly></v-text-field>
                                                </v-flex>
                                                <v-flex lg1 md2 sm2 xs5 mr-2>
                                                    <v-text-field v-model="startTime" label="เริ่มส่งเวลา:" v-mask="'##:##'" suffix="น." 
                                                    color="orange accent-3" ref="startTime"></v-text-field>
                                                </v-flex>
                                                <v-flex lg1 md2 sm2 xs5 mr-3>
                                                    <v-text-field v-model="endTime" label="สิ้นสุดส่งเวลา:" v-mask="'##:##'" suffix="น." 
                                                    color="orange accent-3" ref="endTime"></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout>
                                                <v-flex>
                                                    <v-text-field v-model="custAddress" label="ที่อยู่:" color="orange accent-3" readonly></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>

                                        <!-- รายการ SO -->
                                        <template>
                                            <v-divider></v-divider>
                                            <v-data-table :headers="prodHeader" :items="prodList" class="elevation-1" dense 
                                                sort-by="soNo" :items-per-page="prodList.length" hide-default-footer>
                                                <template v-slot:item.prodName="{ item }">
                                                    {{ item.prodName }}<div v-if="item.desc" class="caption grey--text">{{ item.desc }}</div>
                                                </template>
                                                <template v-slot:no-data>
                                                    <v-progress-linear v-if="searchData"  height="10px" v-slot:progress color="orange accent-3" 
                                                    indeterminate></v-progress-linear>
                                                    <v-flex v-if="noData">
                                                        <strong><font color="red">ไม่พบข้อมูล</font></strong>
                                                    </v-flex>
                                                </template>
                                            </v-data-table>
                                            <v-layout>
                                                <v-flex lg6 md6 sm6 xs6 text-right><strong>รวม</strong></v-flex>
                                                <v-flex lg2 md2 sm2 xs5 text-right>
                                                    <strong>
                                                        {{totalVolume.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                                                    </strong>
                                                </v-flex>
                                            </v-layout>
                                            <v-divider></v-divider>
                                        </template>

                                        <!-- รายการ RT -->
                                        <template v-if="prodListRt.length > 0">
                                            <h2><font color="red">สินค้ารับคืน</font></h2>
                                            <v-divider></v-divider>
                                            <v-data-table :headers="prodHeaderRt" :items="prodListRt" class="elevation-1" dense 
                                                sort-by="soNo" :items-per-page="prodListRt.length" hide-default-footer>
                                            </v-data-table>
                                            <br>
                                        </template>
                                        
                                    </v-card>
                                    <v-divider></v-divider>
                                    <br>
                                    <v-layout>
                                        <v-flex text-right mr-1>
                                            <v-btn v-if="searchSo" @click="addSo" color="green" dark>ตกลง</v-btn>
                                            <v-btn v-if="searchRT" @click="addRt" color="green" dark>ตกลง</v-btn>
                                        </v-flex>
                                        <v-flex text-left ml-1>
                                            <v-btn color="red" @click="cancelAddSo" dark tabindex="-1">ยกเลิก</v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </v-dialog>
                    </v-layout>
                    <br>
                    <v-divider></v-divider>

                    <!-- รายการ SO -->
                    <!-- พิกัด: whether each SO's job reaches the driver with a pin.
                         The rows are read from deliveryList (sheetRows), since
                         soList holds only what the table prints. -->
                    <div v-if="soList.length" class="caption mb-1">
                        <span v-if="sheetPinMissing" class="orange--text text--darken-3">
                            <v-icon small color="orange darken-3">mdi-map-marker-off-outline</v-icon>
                            ไม่มีพิกัด {{ sheetPinMissing }} / {{ soList.length }} SO
                        </span>
                        <span v-else class="green--text text--darken-1">
                            <v-icon small color="green darken-1">mdi-map-marker-check</v-icon>
                            มีพิกัดครบทุก SO
                        </span>
                    </div>
                    <div v-if="soList.length" class="text-right">
                        <v-btn x-small text color="orange darken-3" @click="toggleAllProducts('so')">
                            <v-icon small left>{{ expandedSo.length ? 'mdi-unfold-less-horizontal' : 'mdi-unfold-more-horizontal' }}</v-icon>
                            {{ expandedSo.length ? 'ย่อทั้งหมด' : 'ขยายทั้งหมด' }}
                        </v-btn>
                    </div>
                    <v-data-table :headers="soHeaderShown" :items="soLines" :items-per-page="100"
                    hide-default-footer dense class="elevation-1"
                    item-key="soNo" show-expand :expanded.sync="expandedSo">
                        <template v-slot:item.planDay="{ item }">
                            <span v-if="item.planDay" class="caption">วันที่ {{ item.planDay }} · {{ item.planDate }}</span>
                        </template>
                        <template v-slot:item.cust="{ item }">
                            <div class="sheet-cust py-1">
                                <div class="body-2">{{ item.custName }}</div>
                                <div class="caption grey--text text--darken-1 sheet-cust-addr">{{ item.custAddress }}</div>
                            </div>
                        </template>
                        <template v-slot:item.products="{ item }">
                            <span class="caption">{{ productCountText(sheetRowForSo(item)) }}</span>
                        </template>
                        <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length" class="py-2">
                                <product-lines :row="sheetRowForSo(item)" />
                            </td>
                        </template>
                        <template v-slot:no-data>
                            <v-progress-linear v-if="searchData"  height="10px" v-slot:progress color="orange accent-3" 
                            indeterminate></v-progress-linear>
                            <v-flex v-if="noData">
                                <strong><font color="red">ไม่พบข้อมูล</font></strong>
                            </v-flex>
                        </template>
                        <template v-slot:item.pin="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on" :disabled="!pinRowFor(item)" @click="openListPin(item)"
                                        :color="hasPin(item) ? 'green darken-1' : 'grey lighten-1'">
                                        {{ hasPin(item) ? 'mdi-map-marker-check' : 'mdi-map-marker-off-outline' }}
                                    </v-icon>
                                </template>
                                <span v-if="!pinRowFor(item)">กำลังโหลด...</span>
                                <span v-else-if="hasPin(item)">มีพิกัดแล้ว — คลิกเพื่อแก้ไข
                                    <template v-if="pinRowFor(item).landmark"><br>จุดสังเกต: {{ pinRowFor(item).landmark }}</template>
                                </span>
                                <span v-else>ยังไม่มีพิกัด — คลิกเพื่อเพิ่ม</span>
                            </v-tooltip>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-hover v-slot:default="{ hover }">
                                        <v-icon :color="hover ? 'orange accent-4' : null" @click="editSO(item)" 
                                        v-on="on">mdi-file-document-edit</v-icon>
                                    </v-hover>
                                </template>
                                <span>แก้ไข SO</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-hover v-slot:default="{ hover }">
                                        <v-icon :color="hover ? 'red' : null" @click="delSo(item)" v-on="on">mdi-delete</v-icon>
                                    </v-hover>
                                </template>
                                <span>ลบ SO</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                    <list-pin-dialog v-model="pinDialog.open" :row="pinDialog.row" @saved="loadSheetPins" />
                    <br>

                    <!-- รายการ RT -->
                    <v-divider></v-divider>
                    <div v-if="rtList.length" class="text-right">
                        <v-btn x-small text color="orange darken-3" @click="toggleAllProducts('rt')">
                            <v-icon small left>{{ expandedRt.length ? 'mdi-unfold-less-horizontal' : 'mdi-unfold-more-horizontal' }}</v-icon>
                            {{ expandedRt.length ? 'ย่อทั้งหมด' : 'ขยายทั้งหมด' }}
                        </v-btn>
                    </div>
                    <v-data-table :headers="rtHeaderShown" :items="rtLines" :items-per-page="100"
                    hide-default-footer dense class="elevation-1"
                    item-key="rtNo" show-expand :expanded.sync="expandedRt">
                        <template v-slot:item.planDay="{ item }">
                            <span v-if="item.planDay" class="caption">วันที่ {{ item.planDay }} · {{ item.planDate }}</span>
                        </template>
                        <template v-slot:item.cust="{ item }">
                            <div class="sheet-cust py-1">
                                <div class="body-2">{{ item.custName }}</div>
                                <div class="caption grey--text text--darken-1 sheet-cust-addr">{{ item.custAddress }}</div>
                            </div>
                        </template>
                        <template v-slot:item.products="{ item }">
                            <span class="caption">{{ productCountText(sheetRowForRt(item)) }}</span>
                        </template>
                        <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length" class="py-2">
                                <product-lines :row="sheetRowForRt(item)" />
                            </td>
                        </template>
                        <template v-slot:no-data>
                            <v-progress-linear v-if="searchData"  height="10px" v-slot:progress color="orange accent-3" 
                            indeterminate></v-progress-linear>
                            <v-flex v-if="noData">
                                <strong><font color="red">ไม่พบข้อมูล</font></strong>
                            </v-flex>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-hover v-slot:default="{ hover }">
                                        <v-icon :color="hover ? 'orange accent-4' : null" @click="editRT(item)" 
                                        v-on="on">mdi-file-document-edit</v-icon>
                                    </v-hover>
                                </template>
                                <span>แก้ไข RT</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-hover v-slot:default="{ hover }">
                                        <v-icon :color="hover ? 'red' : null" @click="delRt(item)" v-on="on">mdi-delete</v-icon>
                                    </v-hover>
                                </template>
                                <span>ลบ RT</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>

                    <!-- <template v-if="showBtnManageCar"> -->
                    <template>
                        <br>
                        <v-divider></v-divider>
                        <!-- <br> -->
                        <!-- <v-layout>
                            <v-flex text-center>
                                <v-hover v-slot:default="{ hover }">
                                    <v-btn :color="hover ? 'red' : null" text @click="clearPage">
                                        <v-icon>mdi-cached</v-icon>
                                        ล้างค่า
                                    </v-btn>
                                </v-hover>
                            </v-flex>
                        </v-layout> -->
                    </template>
                </v-card-text>
            </v-card>

            <!-- แสดงหน้า SO หรือ RT ที่ถูกจัดรถไปแล้ว -->
            <v-dialog v-model="showUpdateSO" persistent>
                <v-card>
                    <br>
                    <v-card-text>
                        <v-layout>
                            <v-flex v-if="editSoNo"><strong>เลขที่ SO: {{editSoNo}}</strong></v-flex>
                            <v-flex v-else><strong>เลขที่ RT: {{editRtNo}}</strong></v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex><strong>วันที่ขึ้นของ: {{editLoadDate}}</strong></v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex><strong>วันที่ส่งของ: {{editDelDate}}</strong></v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex><strong>คนขับรถ: {{editDriver}}</strong></v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex><strong>เลขทะเบียน: {{editRegNum}}</strong></v-flex>
                        </v-layout>

                        <!-- ส่วนหัว -->
                        <v-layout wrap>
                            <v-flex lg2 md2 sm3 xs9 mr-2>
                                <strong>รหัสร้านค้า: {{editCardCode}}</strong>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex lg6 md8 sm9 xs12>
                                <strong>ชื่อร้านค้า: {{editCardName}}</strong>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex lg6 md8 sm9 xs12>
                                <strong>ชื่อลูกค้า: {{editCustName}}</strong>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex lg2 md2 sm2 xs4 mr-2>
                                <v-text-field v-model="editTimeSt" label="เริ่มส่งเวลา:" v-mask="'##:##'" suffix="น." 
                                color="orange accent-3" ref="editTimeSt"></v-text-field>
                            </v-flex>
                            <v-flex lg2 md2 sm2 xs4>
                                <v-text-field v-model="editTimeEnd" label="สิ้นสุดส่งเวลา:" v-mask="'##:##'" suffix="น." 
                                color="orange accent-3" ref="editTimeEnd"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <template v-if="editProdList.length > 0">
                            <v-data-table :headers="prodHeader" :items="editProdList" class="elevation-1" dense 
                                sort-by="soNo" :items-per-page="editProdList.length" hide-default-footer>
                                                <template v-slot:item.prodName="{ item }">
                                                    {{ item.prodName }}<div v-if="item.desc" class="caption grey--text">{{ item.desc }}</div>
                                                </template>
                                <template v-slot:no-data>
                                    <v-progress-linear v-if="searchData"  height="10px" v-slot:progress color="orange accent-3" 
                                    indeterminate></v-progress-linear>
                                    <v-flex v-if="noData">
                                        <strong><font color="red">ไม่พบข้อมูล</font></strong>
                                    </v-flex>
                                </template>
                            </v-data-table>
                        </template>
                        <template v-if="editProdListRt.length > 0">
                            <v-layout mt-3>
                                <v-flex>
                                    <h2><font color="red">สินค้ารับคืน</font></h2>
                                    <v-divider></v-divider>
                                    <v-data-table :headers="prodHeaderRt" :items="editProdListRt" class="elevation-1" dense 
                                        sort-by="soNo" :items-per-page="editProdListRt.length" hide-default-footer>
                                    </v-data-table>
                                </v-flex>
                            </v-layout>
                            <br>
                        </template>
                        <br>
                        <v-divider></v-divider>
                        <br>
                        <v-layout>
                            <v-flex text-right mr-2>
                                <v-btn v-if="searchSo" text @click="showUpSO" color="green" dark>ตกลง</v-btn>
                                <v-btn v-if="searchRT" text @click="showUpRT" color="green" dark>ตกลง</v-btn>
                            </v-flex>
                            <v-flex text-left>
                                <v-btn text @click="cancelUpdate" color="red" dark>ยกเลิก</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <!-- แสดงหน้าแก้ไข SO -->
            <v-dialog v-model="showEditSO" persistent  width="unset">
                <v-card>
                    <br>
                    <v-card-text>
                        <v-layout>
                            <v-flex lg4 md4 sm4 xs5 mr-2>
                                <v-text-field v-model="editSoNo" color="orange accent-3"
                                label="เลขที่ SO:" readonly></v-text-field>
                            </v-flex>
                            <v-flex mr-2>
                                <v-text-field v-model="editTimeSt" label="เริ่มส่งเวลา:" v-mask="'##:##'" suffix="น." 
                                color="orange accent-3" ref="editTimeSt"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field v-model="editTimeEnd" label="สิ้นสุดส่งเวลา:" v-mask="'##:##'" suffix="น." 
                                color="orange accent-3" ref="editTimeEnd"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <br>
                        <v-layout>
                            <v-flex text-right mr-2>
                                <v-btn text @click="confiEditSO" color="green" dark>ตกลง</v-btn>
                            </v-flex>
                            <v-flex text-left>
                                <v-btn text @click="cancelEdit" color="red" dark>ยกเลิก</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <!-- แสดงหน้าแก้ไข RT -->
            <v-dialog v-model="showEditRT" persistent  width="unset">
                <v-card>
                    <br>
                    <v-card-text>
                        <v-layout>
                            <v-flex lg4 md4 sm4 xs5 mr-2>
                                <v-text-field v-model="editRtNo" color="orange accent-3"
                                label="เลขที่ RT:" readonly></v-text-field>
                            </v-flex>
                            <v-flex mr-2>
                                <v-text-field v-model="editTimeSt" label="เริ่มส่งเวลา:" v-mask="'##:##'" suffix="น." 
                                color="orange accent-3" ref="editTimeSt"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field v-model="editTimeEnd" label="สิ้นสุดส่งเวลา:" v-mask="'##:##'" suffix="น." 
                                color="orange accent-3" ref="editTimeEnd"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <br>
                        <v-layout>
                            <v-flex text-right mr-2>
                                <v-btn @click="confiEditRT" color="green" dark>ตกลง</v-btn>
                            </v-flex>
                            <v-flex text-left>
                                <v-btn @click="cancelEdit" color="red" dark>ยกเลิก</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <!-- Dialog ยืนยันการลบเลขที่ SO -->
            <v-dialog v-model="showDelfindSO"  width="unset" open-on-hover persistent>
                <div class="text-center">
                    <v-card>
                        <v-card-text>
                            <v-layout>
                                <v-flex>
                                    <v-icon :color="delGuardColor" :size="45">mdi-alert-circle-outline</v-icon>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex>
                                    {{msgWarning}}
                                </v-flex>
                            </v-layout>
                            <v-layout v-if="delGuardNote">
                                <v-flex class="pt-2" :class="delGuardTextClass">
                                    {{delGuardNote}}
                                </v-flex>
                            </v-layout>
                            <br>
                            <v-divider></v-divider>
                            <br>
                            <v-layout>
                                <v-flex text-right mr-1>
                                    <v-btn text @click="confiDelFindSO" :color="delGuardOkColor" dark>ตกลง</v-btn>
                                </v-flex>
                                <v-flex text-left ml-1>
                                    <v-btn text color="red" @click="showDelfindSO = false" dark tabindex="-1">ยกเลิก</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </div>
            </v-dialog>

            <!-- Dialog ยืนยันการลบเลขที่ RT -->
            <v-dialog v-model="showDelfindRT"  width="unset" open-on-hover persistent>
                <div class="text-center">
                    <v-card>
                        <v-card-text>
                            <v-layout>
                                <v-flex>
                                    <v-icon :color="delGuardColor" :size="45">mdi-alert-circle-outline</v-icon>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex>
                                    {{msgWarning}}
                                </v-flex>
                            </v-layout>
                            <v-layout v-if="delGuardNote">
                                <v-flex class="pt-2" :class="delGuardTextClass">
                                    {{delGuardNote}}
                                </v-flex>
                            </v-layout>
                            <br>
                            <v-divider></v-divider>
                            <br>
                            <v-layout>
                                <v-flex text-right mr-1>
                                    <v-btn text @click="confiDelFindRT" :color="delGuardOkColor" dark>ตกลง</v-btn>
                                </v-flex>
                                <v-flex text-left ml-1>
                                    <v-btn text color="red" @click="showDelfindRT = false" dark tabindex="-1">ยกเลิก</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </div>
            </v-dialog>

            <!-- Dialog progress -->
            <v-dialog v-model="showDialogProgress"  width="unset" persistent>
                <div class="text-center">
                    <v-card>
                        <v-card-text>
                            <v-progress-circular :size="30" color="orange accent-5" indeterminate></v-progress-circular>
                        </v-card-text>
                    </v-card>
                </div>
            </v-dialog>

            <!-- Dialog Success -->
            <v-dialog v-model="showDialogSuccess"  width="unset" persistent>
                <div class="text-center">
                    <v-card>
                        <v-card-text>
                            <v-layout>
                                <v-flex>
                                    <v-icon color="green" :size="45">mdi-check-circle-outline</v-icon>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex>
                                    บันทึกสำเร็จ!
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </div>
            </v-dialog>

            <!-- Dialog Warning Update SO -->
            <v-dialog v-model="showWarningUpSO"  width="unset" open-on-hover persistent>
                <div class="text-center">
                    <v-card>
                        <v-card-text>
                            <v-layout>
                                <v-flex>
                                    <v-icon color="yellow accent-4" :size="45">mdi-alert-circle-outline</v-icon>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex>
                                    {{msgWarning}}
                                </v-flex>
                            </v-layout>
                            <br>
                            <v-divider></v-divider>
                            <br>
                            <v-layout>
                                <v-flex text-right mr-1>
                                    <v-btn text @click="confiUpdateSO" color="green" dark>ตกลง</v-btn>
                                </v-flex>
                                <v-flex text-left ml-1>
                                    <v-btn text color="red" @click="showWarningUpSO = false" dark tabindex="-1">ยกเลิก</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </div>
            </v-dialog>

            <!-- Dialog Warning Update RT -->
            <v-dialog v-model="showWarningUpRT"  width="unset" open-on-hover persistent>
                <div class="text-center">
                    <v-card>
                        <v-card-text>
                            <v-layout>
                                <v-flex>
                                    <v-icon color="yellow accent-4" :size="45">mdi-alert-circle-outline</v-icon>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex>
                                    {{msgWarning}}
                                </v-flex>
                            </v-layout>
                            <br>
                            <v-divider></v-divider>
                            <br>
                            <v-layout>
                                <v-flex text-right mr-1>
                                    <v-btn text @click="confiUpdateRT" color="green" dark>ตกลง</v-btn>
                                </v-flex>
                                <v-flex text-left ml-1>
                                    <v-btn text color="red" @click="showWarningUpRT = false" dark tabindex="-1">ยกเลิก</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </div>
            </v-dialog>

            <!-- Dialog Warning SO -->
            <v-dialog v-model="showWarning"  width="unset" open-on-hover persistent>
                <div class="text-center">
                    <v-card>
                        <v-card-text>
                            <v-layout>
                                <v-flex>
                                    <v-icon :color="delGuardColor" :size="45">mdi-alert-circle-outline</v-icon>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex>
                                    {{msgWarning}}
                                </v-flex>
                            </v-layout>
                            <v-layout v-if="delGuardNote">
                                <v-flex class="pt-2" :class="delGuardTextClass">
                                    {{delGuardNote}}
                                </v-flex>
                            </v-layout>
                            <br>
                            <v-divider></v-divider>
                            <br>
                            <v-layout>
                                <v-flex text-right mr-1>
                                    <v-btn text @click="confiDel" :color="delGuardOkColor" dark>ตกลง</v-btn>
                                </v-flex>
                                <v-flex text-left ml-1>
                                    <v-btn text color="red" @click="showWarning = false" dark tabindex="-1">ยกเลิก</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </div>
            </v-dialog>

            <!-- Dialog Warning RT -->
            <v-dialog v-model="showWarningRT"  width="unset" open-on-hover persistent>
                <div class="text-center">
                    <v-card>
                        <v-card-text>
                            <v-layout>
                                <v-flex>
                                    <v-icon :color="delGuardColor" :size="45">mdi-alert-circle-outline</v-icon>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex>
                                    {{msgWarningRT}}
                                </v-flex>
                            </v-layout>
                            <v-layout v-if="delGuardNote">
                                <v-flex class="pt-2" :class="delGuardTextClass">
                                    {{delGuardNote}}
                                </v-flex>
                            </v-layout>
                            <br>
                            <v-divider></v-divider>
                            <br>
                            <v-layout>
                                <v-flex text-right mr-1>
                                    <v-btn text @click="confiDelRt" :color="delGuardOkColor" dark>ตกลง</v-btn>
                                </v-flex>
                                <v-flex text-left ml-1>
                                    <v-btn text color="red" @click="showWarningRT = false" dark tabindex="-1">ยกเลิก</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </div>
            </v-dialog>

            <!-- Dialog Error -->
            <v-dialog v-model="showDialogError" width="unset">
                <div class="text-center">
                    <v-card>
                        <v-card-text>
                            <v-layout>
                                <v-flex>
                                    <v-icon color="red" :size="45">mdi-close-circle-outline</v-icon>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex>
                                    {{msgError}}
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </div>
            </v-dialog>

            <!-- Dialog ลบสำเร็จ -->
            <v-dialog v-model="showDelSuccess"  width="unset" persistent>
                <div class="text-center">
                    <v-card>
                        <v-card-text>
                            <v-layout>
                                <v-flex>
                                    <v-icon color="green" :size="45">mdi-check-circle-outline</v-icon>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex>
                                    ลบสำเร็จ!
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </div>
            </v-dialog>

        </v-container>
    </v-app>
</template>
<script>
import mainMenu from '@/components/mainMenu'
// import config from '@/components/config'
import axios from 'axios'
import {reportError} from '@/components/report'
import {db} from '@/firebase'
import driverService from '@/components/driverService'
import driverDay from '@/components/driverDay'
import R from '@/components/bookingRules'
import dispatchService from '@/components/dispatchService'
import listPinDialog from '@/components/listPinDialog'
import productLines from '@/components/sheetProducts'
import DR from '@/components/deliveryRow'
export default {
    components:{
        mainMenu,
        listPinDialog,
        productLines
    },
    data(){
        return{
            dialogEditInfoManageCar: false,
            mc: {
                transNo: '',
                loadDate: '',
                delDate: '',
                driver: '',
                regNum: '',
                menuLoadDate: false,
                menuDeliDate: false,
            },
            dialogChangeCarTimeSO: false,
            dialogChangeCarTimeRT: false,
            hideBtnDel: false,
            showDelfindRT: false,
            showDelfindSO: false,
            // What the driver has already stamped for the job the open delete
            // dialog is about. Refreshed by loadDelGuard() before EVERY delete
            // dialog opens, so a warning can never be left over from the last
            // one; `known: true` with nothing stamped is the ordinary case and
            // shows no extra line at all.
            delGuard: { known: true, stamped: false, finished: false, status: 'pending', lastStep: null, lastAt: '' },
            dialogFindManageCar: false,
            findNoManageCar: '',
            showArrSOAndRT: false,
            find: { 
                id: '',
                idTimeline: '',
                soNo: '',
                rtNo: '',
                transNo: '',
                loadDate: '', 
                delDate: '', 
                driver: '', 
                regNum: '',
                time: ''
            },
            headerFindSO: [
                { text: 'เลขที่ SO', sortable: false, align: 'left', value: 'soNo' },
                { text: 'เวลาส่ง', sortable: false, align: 'left', value: 'time' },
                { text: '', sortable: false, align: 'right', value: 'action' },
            ],
            arrSO: [],
            dialogChangeTimeSO: false,
            dialogChangeTimeRT: false,
            time: { st: '', end: '' },
            headerFindRT: [
                { text: 'เลขที่ RT', sortable: false, align: 'left', value: 'rtNo' },
                { text: 'เวลาส่ง', sortable: false, align: 'left', value: 'time' },
                { text: '', sortable: false, align: 'right', value: 'action' },
            ],
            arrRT: [],

            dialogFindSO: false,
            findNoSO: '',
            dialogFindRT: false,
            findNoRT: '',
            showWarningUpRT: false,
            showWarningUpSO: false,
            showUpdateSO: false,
            showEditManageCar: false,
            showBtnManageCar: false,
            showDialogProgress: false,
            showDialogSuccess: false,
            showDialogError: false,
            msgError: '',
            showWarning: false,
            msgWarning: '',
            showWarningRT: false,
            msgWarningRT: '',
            showDelSuccess: false,
            // webPath:config.webPath,
            menuLoadDate: false,
            menuDeliDate: false,
            loadDate: new Date().toISOString().substr(0, 10),
            deliDate: new Date().toISOString().substr(0, 10),
            nowDate: new Date().toISOString().substr(0, 10),

            transNo: '',
            driverItem: ["1 - ไม่มีข้อมูล"],
            regNumItem: ["ไม่มีข้อมูล"],
            driver: '',
            regNum: '',

            searchSo: '',
            searchRT: '',
            docEntry: '',
            soNo: '',
            poNo: '',
            rulesFindSO: [
                v => v.length == 9 || 'โปรดระบุเลขที่ SO ทั้งหมด 9 หลัก'
            ],
            rulesSo: [
                v => v.length == 9 || 'โปรดระบุเลขที่ SO ทั้งหมด 9 หลัก'
            ],
            rulesFindRT: [
                v => v.length == 9 || 'โปรดระบุเลขที่ RT ทั้งหมด 9 หลัก'
            ],
            rulesRt: [
                v => v.length == 9 || 'โปรดระบุเลขที่ RT ทั้งหมด 9 หลัก'
            ],
            showNewService: false,
            showNewSo: false,
            showEditSO: false,
            showEditRT: false,
            showCust: false,
            searchData: false,
            noData: true,

            cardCode: '',
            cardPhone: '',
            cardName: '',

            custName: '',
            custTel: '',
            startTime: '',
            endTime: '',
            custAddress: '',
            // SAP's U_KSK_Geolocation / U_KSK_Landmark, via R.soPin (getSo).
            geo: '',
            landmark: '',
            city: '',
            payMent: '',
            transferAmt: '',

            prodHeader:[
                { text: 'เลขที่ SO', sortable: false, align: 'left', value: 'soNo' },
                { text: 'รหัสสินค้า', sortable: false, align: 'left', value: 'prodCode' },
                // SAP's item description is prodName (RDR1.Dscription); desc is the
                // line's own free text (RDR1.Text), usually blank, shown under it.
                { text: 'รายละเอียดสินค้า', sortable: false, align: 'left', value: 'prodName' },
                { text: 'โครง', sortable: false, align: 'center', value: 'frame' },
                { text: 'บาน', sortable: false, align: 'center', value: 'front' },
                { text: 'จำนวน', sortable: false, align: 'right', value: 'qty' },
                { text: 'ปริมาตร', sortable: false, align: 'right', value: 'volume' },
                { text: 'เกรด', sortable: false, align: 'center', value: 'grade' },
                { text: 'เลขที่ PO', sortable: false, align: 'left', value: 'poNo' },
                { text: 'หมายเหตุ', sortable: false, align: 'left', value: 'remark' },
                // { text: '', sortable: false, value: 'action' },
            ],
            prodList: [],

            prodServiceHeader:[
                { text: 'เลขที่ SO', sortable: false, align: 'left', value: 'soNo' },
                { text: 'รหัสสินค้า', sortable: false, align: 'left', value: 'prodCode' },
                { text: 'รายละเอียด', sortable: false, align: 'left', value: 'desc' },
                { text: 'โครง', sortable: false, align: 'center', value: 'frame' },
                { text: 'บาน', sortable: false, align: 'center', value: 'front' },
                { text: 'จำนวน', sortable: false, align: 'right', value: 'qty' },
                // { text: 'ราคาค่าซ่อม', sortable: false, align: 'right', value: 'price' },
            ],

            soHeader: [
                { text: 'เลขที่ SO', sortable: false, align: 'left', value: 'soNo' },
                { text: 'ลูกค้า', sortable: false, align: 'left', value: 'cust' },
                { text: 'วันส่ง', sortable: false, align: 'left', value: 'planDay' },
                { text: 'เวลาส่ง', sortable: false, align: 'left', value: 'time' },
                { text: 'รายการสินค้า', sortable: false, align: 'left', value: 'products' },
                { text: 'พิกัด', sortable: false, align: 'center', value: 'pin' },
                { text: '', sortable: false, align: 'right', value: 'action' },
                { text: '', value: 'data-table-expand' },
            ],
            rtHeader: [
                { text: 'เลขที่ RT', sortable: false, align: 'left', value: 'rtNo' },
                { text: 'ลูกค้า', sortable: false, align: 'left', value: 'cust' },
                { text: 'วันส่ง', sortable: false, align: 'left', value: 'planDay' },
                { text: 'เวลาส่ง', sortable: false, align: 'left', value: 'time' },
                { text: 'รายการสินค้า', sortable: false, align: 'left', value: 'products' },
                { text: '', sortable: false, align: 'right', value: 'action' },
                { text: '', value: 'data-table-expand' },
            ],
            soList: [],
            rtList: [],
            // Rows opened to show their products; collapsed by default.
            expandedSo: [],
            expandedRt: [],
            // deliveryList rows of this ใบจัดรถ, for the พิกัด and
            // รายการสินค้า columns (loadSheetPins).
            sheetRows: [],
            sheetSeq: 0,
            pinDialog: { open: false, row: null },

            idSo: '',
            idTrack: '',
            idRt: '',

            prodHeaderRt: [
                { text: 'เลขที่ RT', sortable: false, align: 'left', value: 'rtNo' },
                { text: 'รหัสสินค้า', sortable: false, align: 'left', value: 'prodName' },
                { text: 'โครง', sortable: false, align: 'center', value: 'frame' },
                { text: 'บาน', sortable: false, align: 'center', value: 'front' },
                { text: 'จำนวน', sortable: false, align: 'center', value: 'qty' },
                { text: 'สาเหตุ', sortable: false, align: 'left', value: 'remark' },
                { text: 'วิธีแก้ไข', sortable: false, align: 'left', value: 'solution' },
            ],
            prodListRt: [],
            rtNo: '',
            docEntryRT: '',

            editId: '',
            editIdTimeline: '',
            editSoNo: '',
            editRtNo: '',
            editDriver: '',
            editRegNum: '',
            editLoadDate: '',
            editDelDate: '',
            editCardCode: '',
            editCardName: '',
            editCustName: '',
            editTimeSt: '',
            editTimeEnd: '',
            editProdList: [],
            editProdListRt: [],

            findSo: '',
        }
    },
    methods:{

        // หากเปลี่ยนวันขึ้นของ วันส่งของจะถูกเปลี่ยนตามด้วย *หน้าจัดรถ
        dateManageCar(){
            this.deliDate = this.loadDate
        },

        // หากเปลี่ยนวันขึ้นของ วันส่งของจะถูกเปลี่ยนตามด้วย *หน้าแก้ไขใบจัดรถ
        dateTransNo(){
            this.mc.delDate = this.mc.loadDate
        },

        // ค้นหาเลขที่ใบจัดรถ
        findManageCar(){
            let app = this
            if(!this.findNoManageCar){
                this.$nextTick(()=>this.$refs.findNoManageCar.focus())
            }
            else{
                app.showArrSOAndRT = false
                app.hideBtnDel = false
                app.showDialogProgress = true
                db.collection("deliveryList").where("transNo", "==", app.findNoManageCar).get()
                .then(query=>{
                    app.arrSO = []
                    app.arrRT = []
                    if(query.docs.length == 0){
                        app.showArrSOAndRT = false
                        app.showDialogProgress = false
                        app.msgError = "ไม่พบเลขที่ " + app.findNoManageCar + " ในระบบ"
                        app.showDialogError = true
                        setTimeout(()=>{
                            app.showDialogError = false
                        },1500)
                    }
                    else{
                        let i = 0
                        let j = 0
                        query.forEach(doc=>{
                            app.find.loadDate = doc.data().loadDate
                            app.find.delDate = doc.data().deliveryDate
                            app.find.driver = doc.data().driver
                            app.find.regNum = doc.data().regNum
                            if(doc.data().soNo){
                                db.collection("deliveryTimeline").where("trackNo", "==", doc.data().soNo).get()
                                .then(queryTimeline=>{
                                    app.arrSO.push({ id: query.docs[i].id, idTimeline: queryTimeline.docs[0].id, 
                                    soNo: doc.data().soNo, rtNo: doc.data().rtNo, time: doc.data().time })
                                    i++
                                    j++
                                    callback()
                                })
                            }
                            else{
                                db.collection("deliveryTimeline").where("trackNo", "==", doc.data().rtNo).get()
                                .then(queryTimeline=>{
                                    app.arrRT.push({ id: query.docs[i].id, idTimeline: queryTimeline.docs[0].id,
                                    rtNo: doc.data().rtNo, time: doc.data().time })
                                    i++
                                    j++
                                    callback()
                                })
                            }
                        })
                        let callback = function
                        callback(){
                            if(i === j){
                                app.showDialogProgress = false
                                app.hideBtnDel = true
                                app.showArrSOAndRT = true
                            }
                        }
                    }

                })
            }
        },

        // ค้นหาเลขที่ SO
        findManageSO(){
            if(!this.$refs.findNoSO.validate()){
                this.$nextTick(()=>this.$refs.findNoSO.focus())
            }
            else{
                this.showDialogProgress = true
                db.collection("deliveryList").where("soNo", "==", this.findNoSO).get()
                .then(query=>{
                    if(query.docs.length == 0){
                        this.showArrSOAndRT = false
                        this.showDialogProgress = false
                        this.hideBtnDel = false
                        this.msgError = "ไม่พบเลขที่ SO: " + this.findNoSO + " ในระบบ"
                        this.showDialogError = true
                        setTimeout(()=>{
                            this.showDialogError = false
                            // this.searchSo = this.findNoSO
                            // this.closeFind()
                            // this.$nextTick(()=>this.$refs.searchSo.focus())
                        },1500)
                    }
                    else{
                        db.collection("deliveryTimeline").where("trackNo", "==", this.findNoSO).get()
                        .then(queryTimeline=>{
                            query.forEach(doc=>{
                                this.find.id = query.docs[0].id
                                this.find.idTimeline = queryTimeline.docs[0].id
                                this.find.soNo = doc.data().soNo
                                this.find.rtNo = doc.data().rtNo
                                this.find.transNo = doc.data().transNo
                                this.find.loadDate = doc.data().loadDate
                                this.find.delDate = doc.data().deliveryDate
                                this.find.driver = doc.data().driver
                                this.find.regNum = doc.data().regNum
                                this.find.time = doc.data().time
                            })
                            this.showDialogProgress = false
                            this.hideBtnDel = true
                            this.showArrSOAndRT = true
                        })
                    }

                })
            }
        },

        // ค้นหาเลขที่ RT
        findManageRT(){
            if(!this.$refs.findNoRT.validate()){
                this.$nextTick(()=>this.$refs.findNoRT.focus())
            }
            else{
                this.showDialogProgress = true
                db.collection("deliveryList").where("rtNo", "==", this.findNoRT).get()
                .then(query=>{
                    if(query.docs.length == 0){
                        this.showArrSOAndRT = false
                        this.showDialogProgress = false
                        this.hideBtnDel = false
                        this.msgError = "ไม่พบเลขที่ RT: " + this.findNoRT + " ในระบบ"
                        this.showDialogError = true
                        setTimeout(()=>{
                            this.showDialogError = false
                            // this.searchRT = this.findNoRT
                            // this.closeFind()
                            // this.$nextTick(()=>this.$refs.searchRT.focus())
                        },1500)
                    }
                    else{
                        db.collection("deliveryTimeline").where("trackNo", "==", this.findNoRT).get()
                        .then(queryTimeline=>{
                            query.forEach(doc=>{
                                this.find.id = query.docs[0].id
                                this.find.idTimeline = queryTimeline.docs[0].id
                                this.find.rtNo = doc.data().rtNo
                                this.find.transNo = doc.data().transNo
                                this.find.loadDate = doc.data().loadDate
                                this.find.delDate = doc.data().deliveryDate
                                this.find.driver = doc.data().driver
                                this.find.regNum = doc.data().regNum
                                this.find.time = doc.data().time
                            })
                            this.showDialogProgress = false
                            this.hideBtnDel = true
                            this.showArrSOAndRT = true
                        })
                    }

                })
            }
        },

        // ปิดหน้าค้นหาต่าง ๆ
        closeFind(){
            this.find.id = ''
            this.find.soNo = ''
            this.find.rtNo = ''
            this.find.transNo = ''
            this.find.loadDate = ''
            this.find.delDate = ''
            this.find.driver = ''
            this.find.regNum = ''
            this.find.time = ''
            this.arrSO = []
            this.arrRT = []
            this.showArrSOAndRT = false
            this.dialogFindManageCar = false
            this.dialogFindSO = false
            this.dialogFindRT = false
            this.dialogFindSO = false
            this.dialogFindRT = false
            this.hideBtnDel = false
            this.findNoManageCar = ''
            this.findNoSO = ''
            this.findNoRT = ''
            this.time.st = ''
            this.time.end = ''
        },

        editInfoManageCar(){
            this.showDialogProgress = true
            this.mc.transNo = this.findNoManageCar
            this.mc.loadDate = this.find.loadDate
            this.mc.delDate = this.find.delDate
            this.mc.driver = this.find.driver
            this.mc.regNum = this.find.regNum
            this.showDialogProgress = false
            this.dialogEditInfoManageCar = true
            
        },

        confiEditInfoManageCar(){
            let app = this
            let arrSplit = app.mc.driver.split(" - ")
            this.showDialogProgress = true
            let i = 0
            let j = 0
            if(app.arrSO.length > 0){
                app.arrSO.forEach(rec=>{
                    db.collection("deliveryList").doc(rec.id).update({
                        loadDate: app.mc.loadDate,
                        deliveryDate: app.mc.delDate,
                        driver: app.mc.driver,
                        driverName: arrSplit[1],
                        regNum: app.mc.regNum,
                        updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                        updateBy: sessionStorage.user
                    })
                    .then(()=>{
                        db.collection("deliveryTimeline").doc(rec.idTimeline).update({
                            date: app.mc.delDate,
                            driverName: arrSplit[1],
                            regNum: app.mc.regNum
                        })
                        .then(()=>{
                            axios.post(app.webPath+'deliveryWebService.asmx/editSO', {
                                soNo: rec.soNo,
                                loadDate: app.mc.loadDate,
                                delDate: app.mc.delDate,
                                driver: arrSplit[0],
                                regNum: app.mc.regNum,
                            })
                            .then(()=>{
                                if(rec.rtNo){
                                    axios.post(app.webPath+'deliveryWebService.asmx/editRT', {
                                        rtNo: rec.rtNo,
                                        loadDate: app.mc.loadDate,
                                        delDate: app.mc.delDate,
                                        driver: arrSplit[0],
                                        regNum: app.mc.regNum,
                                    })
                                    .then(()=>{
                                        i++
                                        callback()
                                    })
                                    .catch(()=>{
                                        app.showDialogProgress = false
                                        app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiEditInfoManageCar(editRT) has error"
                                        app.showDialogError = true
                                    })
                                }
                                else{
                                    i++
                                    callback()
                                }
                            })
                            .catch(()=>{
                                app.showDialogProgress = false
                                app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiEditInfoManageCar(editSO) has error"
                                app.showDialogError = true
                            })
                        })
                        .catch(()=>{
                            app.showDialogProgress = false
                            app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiEditInfoManageCar(rec.idTimeline) has error"
                            app.showDialogError = true
                        })
                    })
                    .catch(()=>{
                        app.showDialogProgress = false
                        app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiEditInfoManageCar(rec.id) has error"
                        app.showDialogError = true
                    })
                })
            }
            if(app.arrRT.length > 0){
                app.arrRT.forEach(rec=>{
                    db.collection("deliveryList").doc(rec.id).update({
                        loadDate: app.mc.loadDate,
                        deliveryDate: app.mc.delDate,
                        driver: app.mc.driver,
                        driverName: arrSplit[1],
                        regNum: app.mc.regNum,
                        updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                        updateBy: sessionStorage.user
                    })
                    .then(()=>{
                        db.collection("deliveryTimeline").doc(rec.idTimeline).update({
                            date: app.mc.delDate,
                            driverName: arrSplit[1],
                            regNum: app.mc.regNum
                        })
                        .then(()=>{
                            axios.post(app.webPath+'deliveryWebService.asmx/editRT', {
                                rtNo: rec.rtNo,
                                loadDate: app.mc.loadDate,
                                delDate: app.mc.delDate,
                                driver: arrSplit[0],
                                regNum: app.mc.regNum,
                            })
                            .then(()=>{
                                j++
                                callback()
                            })
                            .catch(()=>{
                                app.showDialogProgress = false
                                app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiEditInfoManageCar(editRT) has error"
                                app.showDialogError = true
                            })
                        })
                        .catch(()=>{
                            app.showDialogProgress = false
                            app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiEditInfoManageCar(rec.idTimeline) has error"
                            app.showDialogError = true
                        })
                    })
                    .catch(()=>{
                        app.showDialogProgress = false
                        app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiEditInfoManageCar(rec.id) has error"
                        app.showDialogError = true
                    })
                })
            }
            let callback = function
            callback(){
                if(i === app.arrSO.length && j === app.arrRT.length){
                    app.showDialogProgress = false
                    app.dialogEditInfoManageCar = false
                    app.showDialogSuccess = true
                    setTimeout(()=>{
                        app.find.loadDate = app.mc.loadDate
                        app.find.delDate = app.mc.delDate
                        app.find.driver = app.mc.driver
                        app.find.regNum = app.mc.regNum
                        app.showDialogSuccess = false
                    },2000)
                }
            }
        },

        // แก้ไขเวลา SO
        editFindSO(item){
            this.find.rtNo = ""
            this.time.st = ""
            this.time.end = ""
            this.find.id = item.id
            this.find.idTimeline = item.idTimeline
            this.find.soNo = item.soNo
            if(item.rtNo){
                this.find.rtNo = item.rtNo
            }
            if(item.time){
                let splitTime = item.time.split(" - ")
                this.time.st = splitTime[0]
                this.time.end = splitTime[1]
            }
            this.dialogChangeCarTimeSO = true
            setTimeout(()=>{
                this.$nextTick(()=>this.$refs.st.focus())
            },1)
        },

        // ยืนยันการเปลี่ยนแปลงเวลา SO ในหน้าค้นหาเลขที่ใบจัดรถ
        confiChangeCarTimeSO(){
            let app = this
            this.showDialogProgress = true
            let time = ''
            if(app.time.st && app.time.end){
                time = app.time.st + " - " + app.time.end
            }
            if(app.time.st && app.time.end){
                if(app.time.st.length != 5 || app.time.end.length != 5){
                    app.showDialogProgress = false
                    app.msgError = "โปรดระบุเวลาตามรูปแบบที่กำหนด 00:00"
                    app.showDialogError = true
                }
                else{
                    db.collection("deliveryList").doc(app.find.id).update({
                        time: time,
                        timeUpdate: time,
                        updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                        updateBy: sessionStorage.user
                    })
                    .then(()=>{
                        db.collection("deliveryTimeline").doc(app.find.idTimeline).update({
                        timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}]
                        })
                        .then(()=>{
                            axios.post(app.webPath+'deliveryWebService.asmx/editTimeSO', {
                                soNo: app.find.soNo,
                                serviceTime: time
                            })
                            .then(()=>{
                                if(app.find.rtNo){
                                    axios.post(app.webPath+'deliveryWebService.asmx/editTimeRT', {
                                        rtNo: app.find.rtNo,
                                        serviceTime: time
                                    })
                                    .then(()=>{
                                        app.showDialogProgress = false
                                        app.dialogChangeCarTimeSO = false
                                        app.showDialogSuccess = true
                                        setTimeout(()=>{
                                            let index = app.arrSO.findIndex(i=>i.soNo == app.find.soNo)
                                            app.arrSO[index].time = time
                                            app.showDialogSuccess = false
                                        },2000)
                                    })
                                    .catch(()=>{
                                        app.showDialogProgress = false
                                        app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeCarTimeSO(editTimeRT) has error"
                                        app.showDialogError = true
                                    })
                                }
                                else{
                                    app.showDialogProgress = false
                                    app.dialogChangeCarTimeSO = false
                                    app.showDialogSuccess = true
                                    setTimeout(()=>{
                                        let index = app.arrSO.findIndex(i=>i.soNo == app.find.soNo)
                                        app.arrSO[index].time = time
                                        app.showDialogSuccess = false
                                    },2000)
                                }
                            })
                            .catch(()=>{
                                app.showDialogProgress = false
                                app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeCarTimeSO(editTimeSO) has error"
                                app.showDialogError = true
                            })
                        })
                        .catch(()=>{
                            app.showDialogProgress = false
                            app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeCarTimeSO(find.idTimeline) has error"
                            app.showDialogError = true
                        })
                    })
                    .catch(()=>{
                        app.showDialogProgress = false
                        app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeCarTimeSO(find.id) has error"
                        app.showDialogError = true
                    })
                }
            }
            else{
                db.collection("deliveryList").doc(app.find.id).update({
                    time: time,
                    timeUpdate: time,
                    updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                    updateBy: sessionStorage.user
                })
                .then(()=>{
                    db.collection("deliveryTimeline").doc(app.find.idTimeline).update({
                    timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}]
                    })
                    .then(()=>{
                        axios.post(app.webPath+'deliveryWebService.asmx/editTimeSO', {
                            soNo: app.find.soNo,
                            serviceTime: time
                        })
                        .then(()=>{
                            if(app.find.rtNo){
                                axios.post(app.webPath+'deliveryWebService.asmx/editTimeRT', {
                                    rtNo: app.find.rtNo,
                                    serviceTime: time
                                })
                                .then(()=>{
                                    app.showDialogProgress = false
                                    app.dialogChangeCarTimeSO = false
                                    app.showDialogSuccess = true
                                    setTimeout(()=>{
                                        let index = app.arrSO.findIndex(i=>i.soNo == app.find.soNo)
                                        app.arrSO[index].time = time
                                        app.showDialogSuccess = false
                                    },2000)
                                })
                                .catch(()=>{
                                    app.showDialogProgress = false
                                    app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeCarTimeSO(editTimeRT) has error"
                                    app.showDialogError = true
                                })
                            }
                            else{
                                app.showDialogProgress = false
                                app.dialogChangeCarTimeSO = false
                                app.showDialogSuccess = true
                                setTimeout(()=>{
                                    let index = app.arrSO.findIndex(i=>i.soNo == app.find.soNo)
                                    app.arrSO[index].time = time
                                    app.showDialogSuccess = false
                                },2000)
                            }
                        })
                        .catch(()=>{
                            app.showDialogProgress = false
                            app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeCarTimeSO(editTimeSO) has error"
                            app.showDialogError = true
                        })
                    })
                    .catch(()=>{
                        app.showDialogProgress = false
                        app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeCarTimeSO(find.idTimeline) has error"
                        app.showDialogError = true
                    })
                })
                .catch(()=>{
                    app.showDialogProgress = false
                    app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeCarTimeSO(find.id) has error"
                    app.showDialogError = true
                })
            }
        },

        // แก้ไขเวลา SO
        editFindRT(item){
            this.time.st = ""
            this.time.end = ""
            this.find.id = item.id
            this.find.idTimeline = item.idTimeline
            this.find.rtNo = item.rtNo
            if(item.time){
                let splitTime = item.time.split(" - ")
                this.time.st = splitTime[0]
                this.time.end = splitTime[1]
            }
            this.dialogChangeCarTimeRT = true
            setTimeout(()=>{
                this.$nextTick(()=>this.$refs.st.focus())
            },1)
        },

        // ยืนยันการเปลี่ยนแปลงเวลา RT ในหน้าค้นหาเลขที่ใบจัดรถ
        confiChangeCarTimeRT(){
            let app = this
            app.showDialogProgress = true
            let time = ''
            if(app.time.st && app.time.end){
                time = app.time.st + " - " + app.time.end
            }
            if(app.time.st && app.time.end){
                if(app.time.st.length != 5 || app.time.end.length != 5){
                    app.showDialogProgress = false
                    app.msgError = "โปรดระบุเวลาตามรูปแบบที่กำหนด 00:00"
                    app.showDialogError = true
                }
                else{
                    db.collection("deliveryList").doc(app.find.id).update({
                        time: time,
                        timeUpdate: time,
                        updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                        updateBy: sessionStorage.user
                    })
                    .then(()=>{
                        db.collection("deliveryTimeline").doc(app.find.idTimeline).update({
                        timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}]
                        })
                        .then(()=>{
                            axios.post(app.webPath+'deliveryWebService.asmx/editTimeRT', {
                                rtNo: app.find.rtNo,
                                serviceTime: time
                            })
                            .then(()=>{
                                app.showDialogProgress = false
                                app.dialogChangeCarTimeRT = false
                                app.showDialogSuccess = true
                                setTimeout(()=>{
                                    let index = app.arrRT.findIndex(i=>i.rtNo == app.find.rtNo)
                                    app.arrRT[index].time = time
                                    app.showDialogSuccess = false
                                },2000)
                            })
                            .catch(()=>{
                                app.showDialogProgress = false
                                app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeCarTimeRT(editTimeRT) has error"
                                app.showDialogError = true
                            })
                        })
                        .catch(()=>{
                            app.showDialogProgress = false
                            app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeCarTimeSO(find.idTimeline) has error"
                            app.showDialogError = true
                        })
                    })
                    .catch(()=>{
                        app.showDialogProgress = false
                        app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeCarTimeRT(find.id) has error"
                        app.showDialogError = true
                    })
                }
            }
            else{
                db.collection("deliveryList").doc(app.find.id).update({
                    time: time,
                    timeUpdate: time,
                    updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                    updateBy: sessionStorage.user
                })
                .then(()=>{
                    db.collection("deliveryTimeline").doc(app.find.idTimeline).update({
                    timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}]
                    })
                    .then(()=>{
                        axios.post(app.webPath+'deliveryWebService.asmx/editTimeRT', {
                            rtNo: app.find.rtNo,
                            serviceTime: time
                        })
                        .then(()=>{
                            app.showDialogProgress = false
                            app.dialogChangeCarTimeRT = false
                            app.showDialogSuccess = true
                            setTimeout(()=>{
                                let index = app.arrRT.findIndex(i=>i.rtNo == app.find.rtNo)
                                app.arrRT[index].time = time
                                app.showDialogSuccess = false
                            },2000)
                        })
                        .catch(()=>{
                            app.showDialogProgress = false
                            app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeCarTimeRT(editTimeRT) has error"
                            app.showDialogError = true
                        })
                    })
                    .catch(()=>{
                        app.showDialogProgress = false
                        app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeCarTimeSO(find.idTimeline) has error"
                        app.showDialogError = true
                    })
                })
                .catch(()=>{
                    app.showDialogProgress = false
                    app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeCarTimeRT(find.id) has error"
                    app.showDialogError = true
                })
            }
        },

        // Asks the driver flow what has already been stamped for the row about
        // to be deleted, and holds the answer for the dialog. Deleting a
        // postponed job is right -- including after the driver has set off, if
        // the customer is not home and reschedules. Deleting one the driver has
        // already FINISHED erases the delivery from deliveryList and
        // deliveryTimeline alike, leaving the record only in an orphaned
        // deliveryStop that nothing reads. So this never refuses; it only makes
        // sure nobody does that without being told. Never throws -- an
        // unreadable guard says so in the dialog and the delete stays available.
        async loadDelGuard(deliveryListId){
            this.delGuard = { known: true, stamped: false, finished: false, status: 'pending', lastStep: null, lastAt: '' }
            this.delGuard = await driverService.stampGuardForListDoc(deliveryListId)
        },

        // ลบ SO
        async delfindSO(){
            this.showDialogProgress = true
            this.msgWarning = "ต้องการลบเลขที่ " + this.find.soNo + " หรือไม่ ?"
            await this.loadDelGuard(this.find.id)
            this.showDialogProgress = false
            this.showDelfindSO = true
        },

        // ยืนยันการลบเลขที่ SO ที่เลือก
        confiDelFindSO(){
            let app = this
            app.showDialogProgress = true
            db.collection("deliveryList").doc(app.find.id).delete()
            .then(()=>{
                db.collection("deliveryTimeline").doc(app.find.idTimeline).delete()
                .then(()=>{
                    axios.post(app.webPath+'deliveryWebService.asmx/CancelSo', {
                        soNo: app.find.soNo
                    })
                    .then(()=>{
                        if(app.find.rtNo){
                            axios.post(app.webPath+'deliveryWebService.asmx/CancelRt', {
                                rtNo: app.find.rtNo
                            })
                            .then(()=>{
                                app.showDialogProgress = false
                                app.closeFind()
                                app.showDelfindSO = false
                                app.showDelSuccess = true
                                setTimeout(() => {
                                    app.showDelSuccess = false
                                }, 1000)
                            })
                            .catch(()=>{
                                app.showDialogProgress = false
                                app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : delfindSO(CancelRt) has error"
                                app.showDialogError = true
                            })
                        }
                        else{
                            app.showDialogProgress = false
                            app.closeFind()
                            app.showDelfindSO = false
                            app.showDelSuccess = true
                            setTimeout(() => {
                                app.showDelSuccess = false
                            }, 1000)
                        }
                    })
                    .catch(()=>{
                        app.showDialogProgress = false
                        app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiDelFindSO(CancelSo) has error"
                        app.showDialogError = true
                    })
                })
                .catch(()=>{
                    app.showDialogProgress = false
                    app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiDelFindSO(find.idTimeline) has error"
                    app.showDialogError = true
                })
            })
            .catch(()=>{
                app.showDialogProgress = false
                app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiDelFindSO(find.id) has error"
                app.showDialogError = true
            })
        },

        // เปลี่ยนแปลงเวลา SO
        ChangeTimeSO(){
            this.time.st = ""
            this.time.end = ""
            if(this.find.time){
                let splitTime = this.find.time.split(" - ")
                this.time.st = splitTime[0]
                this.time.end = splitTime[1]
            }
            this.dialogChangeTimeSO = true
            setTimeout(()=>{
                this.$nextTick(()=>this.$refs.st.focus())
            },1)
        },

        // ยืนยันการเปลี่ยนแปลงเวลา SO
        confiChangeTimeSO(){
            this.showDialogProgress = true
            let app = this
            let time = ''
            if(this.time.st && this.time.end){
                time = this.time.st + " - " + this.time.end
            }
            if(this.time.st && this.time.end){
                if(this.time.st.length != 5 || this.time.end.length != 5){
                    this.showDialogProgress = false
                    this.msgError = "โปรดระบุเวลาตามรูปแบบที่กำหนด 00:00"
                    this.showDialogError = true
                }
                else{
                    db.collection("deliveryList").doc(app.find.id).update({
                        time: time,
                        timeUpdate: time,
                        updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                        updateBy: sessionStorage.user
                    })
                    .then(()=>{
                        db.collection("deliveryTimeline").doc(app.find.idTimeline).update({
                        timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}]
                        })
                        .then(()=>{
                            axios.post(app.webPath+'deliveryWebService.asmx/editTimeSO', {
                                soNo: app.find.soNo,
                                serviceTime: time
                            })
                            .then(()=>{
                                if(app.find.rtNo){
                                    axios.post(app.webPath+'deliveryWebService.asmx/editTimeRT', {
                                        rtNo: app.find.rtNo,
                                        serviceTime: time
                                    })
                                    .then(()=>{
                                        app.showDialogProgress = false
                                        app.showDialogSuccess = true
                                        setTimeout(()=>{
                                            app.find.time = time
                                            app.dialogChangeTimeSO = false
                                            app.showDialogSuccess = false
                                        },2000)
                                    })
                                    .catch(()=>{
                                        app.showDialogProgress = false
                                        app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : editTimeRT() has error"
                                        app.showDialogError = true
                                    })
                                }
                                else{
                                    app.showDialogProgress = false
                                    app.showDialogSuccess = true
                                    setTimeout(()=>{
                                        app.find.time = time
                                        app.dialogChangeTimeSO = false
                                        app.showDialogSuccess = false
                                    },2000)
                                }
                            })
                            .catch(()=>{
                                app.showDialogProgress = false
                                app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : editTimeSO() has error"
                                app.showDialogError = true
                            })
                        })
                        .catch(()=>{
                            app.showDialogProgress = false
                            app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeTimeSO() has error"
                            app.showDialogError = true
                        })
                    })
                    .catch(()=>{
                        app.showDialogProgress = false
                        app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeTimeSO() has error"
                        app.showDialogError = true
                    })
                }
            }
            else{
                db.collection("deliveryList").doc(app.find.id).update({
                    time: time,
                    timeUpdate: time,
                    updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                    updateBy: sessionStorage.user
                })
                .then(()=>{
                    db.collection("deliveryTimeline").doc(app.find.idTimeline).update({
                    timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}]
                    })
                    .then(()=>{
                        axios.post(app.webPath+'deliveryWebService.asmx/editTimeSO', {
                            soNo: app.find.soNo,
                            serviceTime: time
                        })
                        .then(()=>{
                            if(app.find.rtNo){
                                axios.post(app.webPath+'deliveryWebService.asmx/editTimeRT', {
                                    rtNo: app.find.rtNo,
                                    serviceTime: time
                                })
                                .then(()=>{
                                    app.showDialogProgress = false
                                    app.showDialogSuccess = true
                                    setTimeout(()=>{
                                        app.find.time = time
                                        app.dialogChangeTimeSO = false
                                        app.showDialogSuccess = false
                                    },2000)
                                })
                                .catch(()=>{
                                    app.showDialogProgress = false
                                    app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : editTimeRT() has error"
                                    app.showDialogError = true
                                })
                            }
                            else{
                                app.showDialogProgress = false
                                app.showDialogSuccess = true
                                setTimeout(()=>{
                                    app.find.time = time
                                    app.dialogChangeTimeSO = false
                                    app.showDialogSuccess = false
                                },2000)
                            }
                        })
                        .catch(()=>{
                            app.showDialogProgress = false
                            app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : editTimeSO() has error"
                            app.showDialogError = true
                        })
                    })
                    .catch(()=>{
                        app.showDialogProgress = false
                        app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeTimeSO() has error"
                        app.showDialogError = true
                    })
                })
                .catch(()=>{
                    app.showDialogProgress = false
                    app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeTimeSO() has error"
                    app.showDialogError = true
                })
            }
        },

        // ลบ RT
        async delfindRT(){
            this.showDialogProgress = true
            this.msgWarning = "ต้องการลบเลขที่ " + this.find.rtNo + " หรือไม่ ?"
            await this.loadDelGuard(this.find.id)
            this.showDialogProgress = false
            this.showDelfindRT = true
        },

        // ยืนยันการลบเลขที่ SO ที่เลือก
        confiDelFindRT(){
            let app = this
            app.showDialogProgress = true
            db.collection("deliveryList").doc(app.find.id).delete()
            .then(()=>{
                db.collection("deliveryTimeline").doc(app.find.idTimeline).delete()
                .then(()=>{
                    axios.post(app.webPath+'deliveryWebService.asmx/CancelRt', {
                        rtNo: app.find.rtNo
                    })
                    .then(()=>{
                        app.showDialogProgress = false
                        app.closeFind()
                        app.showDelfindRT = false
                        app.showDelSuccess = true
                        setTimeout(() => {
                            app.showDelSuccess = false
                        }, 1000)
                    })
                    .catch(()=>{
                        app.showDialogProgress = false
                        app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiDelFindRT(CancelRt) has error"
                        app.showDialogError = true
                    })
                })
                .catch(()=>{
                    app.showDialogProgress = false
                    app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiDelFindRT(find.idTimeline) has error"
                    app.showDialogError = true
                })
            })
            .catch(()=>{
                app.showDialogProgress = false
                app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiDelFindRT(find.id) has error"
                app.showDialogError = true
            })
        },

        // เปลี่ยนแปลงเวลา RT
        ChangeTimeRT(){
            this.time.st = ""
            this.time.end = ""
            if(this.find.time){
                let splitTime = this.find.time.split(" - ")
                this.time.st = splitTime[0]
                this.time.end = splitTime[1]
            }
            this.dialogChangeTimeRT = true
            setTimeout(()=>{
                this.$nextTick(()=>this.$refs.st.focus())
            },1)
        },

        // ยืนยันการเปลี่ยนแปลงเวลา RT
        confiChangeTimeRT(){
            this.showDialogProgress = true
            let app = this
            let time = ''
            if(this.time.st && this.time.end){
                time = this.time.st + " - " + this.time.end
            }
            if(this.time.st && this.time.end){
                if(this.time.st.length != 5 || this.time.end.length != 5){
                    this.showDialogProgress = false
                    this.msgError = "โปรดระบุเวลาตามรูปแบบที่กำหนด 00:00"
                    this.showDialogError = true
                }
                else{
                    db.collection("deliveryList").doc(app.find.id).update({
                        time: time,
                        timeUpdate: time,
                        updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                        updateBy: sessionStorage.user
                    })
                    .then(()=>{
                        db.collection("deliveryTimeline").doc(app.find.idTimeline).update({
                        timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}]
                        })
                        .then(()=>{
                            axios.post(app.webPath+'deliveryWebService.asmx/editTimeRT', {
                                rtNo: app.find.rtNo,
                                serviceTime: time
                            })
                            .then(()=>{
                                app.showDialogProgress = false
                                app.showDialogSuccess = true
                                setTimeout(()=>{
                                    app.find.time = time
                                    app.dialogChangeTimeRT = false
                                    app.showDialogSuccess = false
                                },2000)
                            })
                            .catch(()=>{
                                app.showDialogProgress = false
                                app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : editTimeRT() has error"
                                app.showDialogError = true
                            })
                        })
                        .catch(()=>{
                            app.showDialogProgress = false
                            app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeTimeRT() has error"
                            app.showDialogError = true
                        })
                    })
                    .catch(()=>{
                        app.showDialogProgress = false
                        app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeTimeRT() has error"
                        app.showDialogError = true
                    })
                }
            }
            else{
                db.collection("deliveryList").doc(app.find.id).update({
                    time: time,
                    timeUpdate: time,
                    updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                    updateBy: sessionStorage.user
                })
                .then(()=>{
                    db.collection("deliveryTimeline").doc(app.find.idTimeline).update({
                    timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}]
                    })
                    .then(()=>{
                        axios.post(app.webPath+'deliveryWebService.asmx/editTimeRT', {
                            rtNo: app.find.rtNo,
                            serviceTime: time
                        })
                        .then(()=>{
                            app.showDialogProgress = false
                            app.showDialogSuccess = true
                            setTimeout(()=>{
                                app.find.time = time
                                app.dialogChangeTimeRT = false
                                app.showDialogSuccess = false
                            },2000)
                        })
                        .catch(()=>{
                            app.showDialogProgress = false
                            app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : editTimeRT() has error"
                            app.showDialogError = true
                        })
                    })
                    .catch(()=>{
                        app.showDialogProgress = false
                        app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeTimeRT() has error"
                        app.showDialogError = true
                    })
                })
                .catch(()=>{
                    app.showDialogProgress = false
                    app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiChangeTimeRT() has error"
                    app.showDialogError = true
                })
            }
        },

        // ค้นหาเลขที่การจัดรถล่าสุด
        getTransNolast(){
            let doc = []
            this.searchSo = ''
            this.searchRT = ''
            axios.post(this.webPath+'deliveryWebService.asmx/GetTransNoLast', {
            })
            .then(response=> {
                doc = JSON.parse(response.data.d)
                this.transNo = doc.transNoLast*1 + 1
                if(this.$route.query.loadDate){
                    this.loadDate = this.$route.query.loadDate
                }
                if(this.$route.query.delDate){
                    this.deliDate = this.$route.query.delDate
                }
                if(this.$route.query.regNum){
                    this.regNum = this.$route.query.regNum
                }
                this.showDialogProgress = false
            })
            .catch(()=>{
                this.showDialogProgress = false
                this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : GetTransNoLast() has error"
                this.showDialogError = true
            })
        },

        // --- พิกัด ---------------------------------------------------------------
        // The deliveryList rows of this ใบจัดรถ, re-read whenever soList changes
        // (load, add, delete) -- soList itself holds only what the table prints.
        async loadSheetPins(){
            const transNo = this.transNo
            const seq = ++this.sheetSeq
            try {
                const rows = await dispatchService.loadSheetRows(transNo)
                if (seq === this.sheetSeq) this.sheetRows = rows
            } catch (error) {
                reportError('Reading the sheet for พิกัด failed', error)
            }
        },
        pinRowFor(item){
            return this.sheetRows.find(r => r.soNo && String(r.soNo) === String(item.soNo)) || null
        },
        // A return on its own is a row with no soNo; an RT sent with an SO lives
        // on the SO's row (prodListRt) and is shown there.
        sheetRowForSo(item){
            return this.pinRowFor(item)
        },
        sheetRowForRt(item){
            return this.sheetRows.find(r => !r.soNo && r.rtNo && String(r.rtNo) === String(item.rtNo)) || null
        },
        // "3 รายการ · 5 ชิ้น", with the returns after it, so a closed row still
        // says whether it is worth opening.
        productCountText(row){
            if (!row) return 'กำลังโหลด...'
            const count = (lines, prefix) => {
                if (!Array.isArray(lines) || !lines.length) return ''
                const pieces = lines.reduce((sum, p) => sum + (Number(p.qty) || 0), 0)
                return `${prefix}${lines.length} รายการ · ${pieces} ชิ้น`
            }
            const parts = [count(row.prodList, ''), count(row.prodListRt, 'คืน ')].filter(Boolean)
            return parts.length ? parts.join(' / ') : 'ไม่มีรายการสินค้า'
        },
        toggleAllProducts(which){
            if (which === 'so') this.expandedSo = this.expandedSo.length ? [] : this.soList.slice()
            else this.expandedRt = this.expandedRt.length ? [] : this.rtList.slice()
        },
        hasPin(item){
            const row = this.pinRowFor(item)
            return !!(row && R.parseGeo(row.geo))
        },
        // The same dialog as คิวรถเล็ก (listPinDialog): reads SAP, writes every row
        // of the customer's stop, then SAP.
        openListPin(item){
            const row = this.pinRowFor(item)
            if (row) this.pinDialog = { open: true, row }
        },

        // ค้นหาเลขที่การจัดรถ โดยการค้นหาด้วยตนเอง
        getTransNo(){
            this.showBtnManageCar = false
            this.loadDate = new Date().toISOString().substr(0,10)
            this.deliDate = new Date().toISOString().substr(0,10)
            this.driver = ''
            this.regNum = ''
            this.soList = []
            this.rtList = []
            this.searchData = true
            this.noData = false
            let app = this
            this.showDialogProgress = true
            db.collection("deliveryList").where("transNo", "==", this.transNo).get()
            .then(query=>{
                if(query.docs.length == 0){
                    this.getTransNolast()
                    this.searchData = false
                    this.noData = true
                }
                else{
                    let i = 0
                    query.forEach(doc=>{
                        if(doc.data().soNo){
                            app.soList.push({ soNo: doc.data().soNo, rtNo: doc.data().rtNo, 
                            id: query.docs[i].id, time: doc.data().time })
                        }
                        else{
                            app.rtList.push({ rtNo: doc.data().rtNo, 
                            id: query.docs[i].id, time: doc.data().time })
                        }
                        this.loadDate = doc.data().loadDate
                        this.deliDate = doc.data().deliveryDate
                        this.driver = doc.data().driver
                        this.regNum = doc.data().regNum
                        i++
                    })
                    if(this.soList.length == 0){
                        this.searchData = false
                        this.noData = true
                    }
                    if(this.rtList.length == 0){
                        this.searchData = false
                        this.noData = true
                    }
                    if(this.soList.length > 0){
                        this.soList.forEach(rec=>{
                            if(rec.soNo){
                                db.collection("deliveryTimeline").where("trackNo", "==", rec.soNo).get()
                                .then(query=>{
                                    rec.idTrack = query.docs[0].id
                                })
                            }
                        })
                    }
                    if(this.rtList.length > 0){
                        this.rtList.forEach(rec=>{
                            db.collection("deliveryTimeline").where("trackNo", "==", rec.rtNo).get()
                            .then(query=>{
                                rec.idTrack = query.docs[0].id
                            })
                        })
                    }
                    this.showBtnManageCar = true
                    this.showDialogProgress = false
                }
            })
        },

        // ยกเลิกการจัดรถ
        clearPage(){
            this.transNo = ''
            this.loadDate = new Date().toISOString().substr(0,10)
            this.deliDate = new Date().toISOString().substr(0,10)
            this.driver = ''
            this.regNum = ''
            this.searchSo = ''
            this.searchRT = ''
            this.soList = []
            this.rtList = []
            this.showBtnManageCar = false
            this.$nextTick(()=>this.$refs.transNo.focus())
        },

        // แสดงข้อมูลคนขับ
        getDriver(){
            let detail = []
            let app = this
            axios.post(this.webPath+'deliveryWebService.asmx/GetDriver', {
            })
            .then(response=> {
                detail = JSON.parse(response.data.d)
                detail.forEach(rec=>{
                    app.driverItem.push(rec.driverCode + " - " + rec.driverDesc)
                })
                // app.driverItem.sort((a, b) => a.driverCode.localeCompare(b.driverCode))
            })
            .then(()=>{
                if(app.$route.query.driver){
                    app.driverItem.forEach(rec=>{
                        let splitArr = rec.split(" - ")
                        let subArr = splitArr.filter(a=>a == app.$route.query.driver)
                        if(subArr.length > 0){
                            app.driver = rec
                        }
                    })
                }
            })
            .catch(()=> {
                this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : GetDriver() has error"
                this.showDialogError = true
            })
        },

        // แสดงข้อมูลทะเบียน
        getRegNum(){
            let detail = []
            let app = this
            axios.post(this.webPath+'deliveryWebService.asmx/GetRegNum', {
            })
            .then(response=> {
                detail = JSON.parse(response.data.d)
                detail.forEach(rec=>{
                    app.regNumItem.push(rec.regNum)
                })
            })
            .catch(()=> {
                this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : GetRegNum() has error"
                this.showDialogError = true
            })
        },

        // ค้นหาเลขที่ SO
        /**
         * Searches for a Sales Order (SO) number and handles the retrieval of related data.
         * 
         * This function performs the following steps:
         * 1. Clears the RT number and searchRT field.
         * 2. Validates the input for the SO number.
         * 3. If the transNo is not set, it checks if the SO number already exists in the deliveryList collection.
         *    - If it exists, it retrieves the transNo, loadDate, deliDate, driver, and regNum from the existing record.
         *    - If it does not exist, it fetches the SO details from the web service and sets the necessary data.
         * 4. If the transNo is set, it checks if the SO number already exists in the current delivery list.
         *    - If it exists, it shows an error message indicating that the SO number is already in the list.
         *    - If it does not exist, it fetches the SO details from the web service and sets the necessary data.
         * 5. Calls getProdList() to fetch the product list associated with the SO.
         * 
         * @param {string} searchSo - The SO number to search for.
         * @returns {void}
         */
        getSo(){
            this.rtNo = ''
            this.searchRT = ''
            let detail = []
            let app = this
            this.soNo = this.searchSo
            // Check valid SO No.
            if(!this.$refs.searchSo.validate()){
                this.$refs.searchSo.focus()
            }
            else{
                app.showDialogProgress = true
                // case no Transfer No.
                if(!app.transNo){
                    app.soList = []
                    db.collection("deliveryList").where("soNo", "==", app.searchSo).get()
                    .then(query=>{
                        // if found soNO then get all tranNo from deliveryList
                        // This means that SO is already has tranfer no.
                        if(query.docs.length > 0){
                            query.forEach(doc=>{
                                db.collection("deliveryList").where("transNo", "==", doc.data().transNo).get()
                                .then(queryTransNo=>{
                                    app.showDialogProgress = false
                                    app.transNo = doc.data().transNo
                                    app.loadDate = doc.data().loadDate
                                    app.deliDate = doc.data().deliveryDate
                                    app.driver = doc.data().driver
                                    app.regNum = doc.data().regNum
                                    app.searchSo = ''
                                    queryTransNo.forEach(rec=>{
                                        app.soList.push({ soNo: rec.data().soNo })
                                    })
                                })
                            })
                        }
                        else{
                            // User must input transNO,driver,regNum(car) first before add new SO
                            if(!app.transNo || !app.driver || !app.regNum){
                                app.showDialogProgress = false
                                if(!app.transNo){
                                    app.$nextTick(()=>app.$refs.transNo.focus())
                                }
                                else if(!app.driver){
                                    app.$nextTick(()=>app.$refs.driver.focus())
                                }
                                else if(!app.regNum){
                                    app.$nextTick(()=>app.$refs.regNum.focus())
                                }
                            }
                            else{
                                axios.post(this.webPath+'deliveryWebService.asmx/GetSo', {
                                    so: app.searchSo
                                })
                                .then(response=> {
                                    detail = JSON.parse(response.data.d)
                                    if(detail.length == 0){
                                        app.msgError = "ไม่พบเลขที่ SO นี้ในระบบ กรุณาลองใหม่อีกครั้ง!"
                                        app.showDialogError = true
                                    }
                                    else{
                                        detail.forEach(rec=>{
                                            app.cardCode = rec.cardCode
                                            app.cardName = rec.cardName
                                            if(rec.phone1 == null){
                                                rec.phone1 = ''
                                                app.cardPhone = rec.phone2
                                            }
                                            if(rec.phone2 == null){
                                                rec.phone2 = ''
                                                app.cardPhone = rec.phone1
                                            }
                                            app.cardPhone = rec.phone1 + " " + rec.phone2

                                            if(rec.custName){
                                                app.custName = rec.custName
                                                app.custTel = rec.custTel
                                                app.custAddress = rec.custAddress
                                                this.showCust = true
                                            }
                                            else{
                                                this.showCust = false
                                            }
                                            if(rec.typePayment != null){
                                                let getTypePayment = []
                                                axios.post(this.webPath+'deliveryWebService.asmx/GetPayment', {
                                                    typePayment: rec.typePayment
                                                })
                                                .then(res=>{
                                                    getTypePayment = JSON.parse(res.data.d)
                                                    getTypePayment.forEach(payMent=>{
                                                        app.payMent = payMent.payment
                                                    })
                                                })
                                            }
                                            if(rec.transferAmt){
                                                app.transferAmt = rec.transferAmt
                                            }
                                            app.city = rec.city
                                            // A pin SAP holds but cannot be read is dropped, not passed to the driver.
                                            const pin = R.soPin(rec)
                                            app.geo = pin.geo
                                            app.landmark = pin.landmark
                                            if(rec.serviceTime && rec.serviceTime.length == 13){
                                                let splitTime = rec.serviceTime.split("-")
                                                app.startTime = splitTime[0].substr(0,5)
                                                app.endTime = splitTime[1].substr(1,6)
                                            }
                                            if(rec.rtNo){
                                                app.rtNo = rec.rtNo
                                                // app.getRT(rec.rtNo)
                                            }
                                        })
                                        app.getProdList()
                                    }
                                })
                                .catch((err)=>{
                                    reportError('GetSo failed', err)
                                    app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : GetSo() has error"
                                    app.showDialogError = true
                                })
                            }
                        }
                    })
                }
                // case has Transfer No.
                else{
                    if(!app.driver || !app.regNum){
                        app.showDialogProgress = false
                        if(!app.driver){
                            app.$nextTick(()=>app.$refs.driver.focus())
                        }
                        else if(!app.regNum){
                            app.$nextTick(()=>app.$refs.regNum.focus())
                        }
                    }
                    else{
                        db.collection("deliveryList").where("soNo", "==", app.searchSo).get()
                        .then(query=>{
                            // case found soNo in deliveryList then open showUpdateSO dialog
                            if(query.docs.length > 0){
                                let fine = app.soList.findIndex(rec=>rec.soNo == app.searchSo)
                                // case found in soList
                                if(fine != -1){
                                    app.showDialogProgress = false
                                    app.msgError = "เลขที่ SO นี้มีอยู่ในใบจัดส่งนี้แล้ว"
                                    app.showDialogError = true
                                }
                                // case not found in soList open showUpdateSO dialog
                                else{
                                    query.forEach(doc=>{
                                        app.showDialogProgress = false
                                        app.editSoNo = app.searchSo
                                        if(doc.data().rtNo){
                                            app.editRtNo = doc.data().rtNo
                                        }
                                        app.editDriver = doc.data().driver
                                        app.editRegNum = doc.data().regNum
                                        if(doc.data().time){
                                            let time = doc.data().time
                                            let splitTime = time.split(" - ")
                                            app.editTimeSt = splitTime[0]
                                            app.editTimeEnd = splitTime[1]
                                        }
                                        app.editLoadDate = doc.data().loadDate
                                        app.editDelDate = doc.data().deliveryDate
                                        app.editCardCode = doc.data().cardCode
                                        app.editCardName = doc.data().cardName
                                        app.editCustName = doc.data().custName
                                        app.editProdList = doc.data().prodList
                                        app.editProdListRt = doc.data().prodListRt
                                        app.editId = query.docs[0].id
                                        db.collection("deliveryTimeline").where("trackNo", "==", app.searchSo).get()
                                        .then(queryTimeline=>{
                                            app.editIdTimeline = queryTimeline.docs[0].id
                                        })
                                        app.showUpdateSO = true
                                    })
                                }
                            }
                            // case not found soNo in deliveryList
                            else{
                                app.showDialogProgress = false
                                axios.post(this.webPath+'deliveryWebService.asmx/GetSo', {
                                    so: app.searchSo
                                })
                                .then(response=> {
                                    detail = JSON.parse(response.data.d)
                                    if(detail.length == 0){
                                        app.msgError = "ไม่พบเลขที่ SO นี้ในระบบ กรุณาลองใหม่อีกครั้ง!"
                                        app.showDialogError = true
                                        // app.getRT(app.searchSo)
                                    }
                                    else{
                                        detail.forEach(rec=>{
                                            app.cardCode = rec.cardCode
                                            app.cardName = rec.cardName
                                            app.cardPhone = (rec.phone1 ? rec.phone1 + " " : '') + 
                                            (rec.phone2 ? rec.phone2 + " " : '') + (rec.phone3 ? rec.phone3 : '')

                                            if(rec.custName){
                                                app.custName = rec.custName
                                                app.custTel = rec.custTel
                                                app.custAddress = rec.custAddress
                                                app.showCust = true
                                            }
                                            else{
                                                app.showCust = false
                                            }
                                            if(rec.typePayment != null){
                                                let getTypePayment = []
                                                axios.post(app.webPath+'deliveryWebService.asmx/GetPayment', {
                                                    typePayment: rec.typePayment
                                                })
                                                .then(res=>{
                                                    getTypePayment = JSON.parse(res.data.d)
                                                    getTypePayment.forEach(payMent=>{
                                                        app.payMent = payMent.payment
                                                    })
                                                })
                                            }
                                            if(rec.transferAmt){
                                                app.transferAmt = rec.transferAmt
                                            }
                                            app.city = rec.city
                                            // A pin SAP holds but cannot be read is dropped, not passed to the driver.
                                            const pin = R.soPin(rec)
                                            app.geo = pin.geo
                                            app.landmark = pin.landmark
                                            if(rec.serviceTime && rec.serviceTime.length == 13){
                                                let splitTime = rec.serviceTime.split("-")
                                                app.startTime = splitTime[0].substr(0,5)
                                                app.endTime = splitTime[1].substr(1,6)
                                            }
                                            if(rec.rtNo){
                                                app.rtNo = rec.rtNo
                                            }
                                        })
                                        // get product list and open showNewSo dialog
                                        app.getProdList()
                                    }
                                })
                                .catch(()=>{
                                    app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : GetSo() has error"
                                    app.showDialogError = true
                                })
                            }
                        })
                    }
                }
            }
        },

        // แสดงรายการสินค้าจาก SO
        getProdList(){
            this.prodList = []
            this.docEntry = ''
            let app = this
            axios.post(this.webPath+'deliveryWebService.asmx/GetProdList', {
                so: app.searchSo
            })
            .then(response=> {
                app.prodList = JSON.parse(response.data.d)
                app.prodList.forEach(rec=>{
                    app.docEntry = rec.docEntry
                    if(rec.poNo){
                        app.poNo = rec.poNo
                    }
                })
            })
            .then(()=>{
                if(app.prodList.length == 0){
                    app.msgError = "ไม่พบสินค้าที่ต้องส่งจากเลขที่ SO นี้ กรุณาลองใหม่อีกครั้ง!"
                    app.showDialogError = true
                }
                else{
                    if(app.rtNo){
                        app.getSoRT(app.rtNo)
                    }
                    else{
                        app.showNewSo = true
                    }
                }
            })
            .catch(()=> {
                this.searchSo = ''
                this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : GetProdList() has error"
                this.showDialogError = true
            })
        },

        // ค้นหาเลขที่ RT ที่อยู่ใน SO
        getSoRT(rtNo){
            let result = []
            let app = this
            axios.post(this.webPath+'deliveryWebService.asmx/GetRT', {
                rtNo: rtNo
            })
            .then(response=>{
                result = JSON.parse(response.data.d)
                if(result.length > 0){
                    app.docEntryRT = result[0].docEntry
                    app.getProdListRt(result[0].docEntry)
                }
                else{
                    app.showNewSo = true
                }
            })
            .catch(()=>{
                app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : GetRT() has error"
                app.showDialogError = true
            })
        },

        // ค้นหาเลขที่ RT
        getRT(){
            this.searchSo = ''
            let result = []
            let app = this
            this.rtNo = this.searchRT
            app.rtList = []
            if(!this.$refs.searchRT.validate()){
                this.$refs.searchRT.focus()
            }
            else{
                app.showDialogProgress = true
                if(!app.transNo){
                    db.collection("deliveryList").where("rtNo", "==", app.searchRT).get()
                    .then(query=>{
                        if(query.docs.length > 0){
                            query.forEach(doc=>{
                                app.showDialogProgress = false
                                app.transNo = doc.data().transNo
                                app.loadDate = doc.data().loadDate
                                app.deliDate = doc.data().deliveryDate
                                app.driver = doc.data().driver
                                app.regNum = doc.data().regNum
                                app.rtList.push({ rtNo: doc.data().rtNo })
                                app.searchRT = ''
                                app.showBtnManageCar = true
                            })
                        }
                        else{
                            if(!app.transNo || !app.driver || !app.regNum){
                                app.showDialogProgress = false
                                if(!app.transNo){
                                    app.$nextTick(()=>app.$refs.transNo.focus())
                                }
                                else if(!app.driver){
                                    app.$nextTick(()=>app.$refs.driver.focus())
                                }
                                else if(!app.regNum){
                                    app.$nextTick(()=>app.$refs.regNum.focus())
                                }
                            }
                            else{
                                axios.post(this.webPath+'deliveryWebService.asmx/GetRT', {
                                    rtNo: app.searchRT
                                })
                                .then(response=>{
                                    app.showDialogProgress = false
                                    result = JSON.parse(response.data.d)
                                    if(result.length == 0){
                                        app.msgError = "ไม่พบเลขที่ RT นี้ในระบบ กรุณาลองใหม่อีกครั้ง!"
                                        app.showDialogError = true
                                    }
                                    else{
                                        result.forEach(rec=>{
                                            app.cardCode = rec.cardCode
                                            app.cardName = rec.cardName
                                            if(rec.phone1 == null){
                                                rec.phone1 = ''
                                                app.cardPhone = rec.phone2
                                            }
                                            if(rec.phone2 == null){
                                                rec.phone2 = ''
                                                app.cardPhone = rec.phone1
                                            }
                                            app.cardPhone = rec.phone1 + " " + rec.phone2

                                            if(rec.custName){
                                                app.custName = rec.custName
                                                app.custTel = rec.custTel
                                                app.custAddress = rec.custAddress
                                                this.showCust = true
                                            }
                                            else{
                                                this.showCust = false
                                            }
                                            if(rec.typePayment != null){
                                                let getTypePayment = []
                                                axios.post(this.webPath+'deliveryWebService.asmx/GetPayment', {
                                                    typePayment: rec.typePayment
                                                })
                                                .then(res=>{
                                                    getTypePayment = JSON.parse(res.data.d)
                                                    getTypePayment.forEach(payMent=>{
                                                        app.payMent = payMent.payment
                                                    })
                                                })
                                            }
                                            if(rec.transferAmt){
                                                app.transferAmt = rec.transferAmt
                                            }
                                            app.city = rec.city
                                            if(rec.serviceTime && rec.serviceTime.length == 13){
                                                let splitTime = rec.serviceTime.split("-")
                                                app.startTime = splitTime[0].substr(0,5)
                                                app.endTime = splitTime[1].substr(1,6)
                                            }
                                        })
                                        app.docEntryRT = result[0].docEntry
                                        app.getProdListRt(result[0].docEntry)
                                    }
                                })
                            }
                        }
                    })
                }
                else{
                    if(!app.driver || !app.regNum){
                        app.showDialogProgress = false
                        if(!app.driver){
                            app.$nextTick(()=>app.$refs.driver.focus())
                        }
                        else if(!app.regNum){
                            app.$nextTick(()=>app.$refs.regNum.focus())
                        }
                    }
                    else{
                        db.collection("deliveryList").where("rtNo", "==", app.searchRT).get()
                        .then(query=>{
                            if(query.docs.length > 0){
                                let fine = app.rtList.findIndex(rec=>rec.rtNo == app.searchRT)
                                if(fine != -1){
                                    app.showDialogProgress = false
                                    app.msgError = "เลขที่ RT นี้มีอยู่ในใบจัดส่งนี้แล้ว"
                                    app.showDialogError = true
                                }
                                else{
                                    query.forEach(doc=>{
                                        app.showDialogProgress = false
                                        app.editRtNo = app.searchRT
                                        app.editDriver = doc.data().driver
                                        app.editRegNum = doc.data().regNum
                                        if(doc.data().time){
                                            let time = doc.data().time
                                            let splitTime = time.split(" - ")
                                            app.editTimeSt = splitTime[0]
                                            app.editTimeEnd = splitTime[1]
                                        }
                                        app.editLoadDate = doc.data().loadDate
                                        app.editDelDate = doc.data().deliveryDate
                                        app.editCardCode = doc.data().cardCode
                                        app.editCardName = doc.data().cardName
                                        app.editCustName = doc.data().custName
                                        app.editProdList = doc.data().prodList
                                        app.editProdListRt = doc.data().prodListRt
                                        app.editId = query.docs[0].id
                                        db.collection("deliveryTimeline").where("trackNo", "==", app.searchRT).get()
                                        .then(queryTimeline=>{
                                            app.editIdTimeline = queryTimeline.docs[0].id
                                        })
                                        app.showUpdateSO = true
                                    })
                                }
                            }
                            else{
                                axios.post(this.webPath+'deliveryWebService.asmx/GetRT', {
                                    rtNo: app.searchRT
                                })
                                .then(response=>{
                                    app.showDialogProgress = false
                                    result = JSON.parse(response.data.d)
                                    if(result.length == 0){
                                        app.msgError = "ไม่พบเลขที่ RT นี้ในระบบ กรุณาลองใหม่อีกครั้ง!"
                                        app.showDialogError = true
                                    }
                                    else{
                                        result.forEach(rec=>{
                                            app.cardCode = rec.cardCode
                                            app.cardName = rec.cardName
                                            // if(rec.phone1 == null){
                                            //     rec.phone1 = ''
                                            //     app.cardPhone = rec.phone2
                                            // }
                                            // if(rec.phone2 == null){
                                            //     rec.phone2 = ''
                                            //     app.cardPhone = rec.phone1
                                            // }
                                            // app.cardPhone = rec.phone1 + " " + rec.phone2

                                            app.cardPhone = (rec.phone1 ? rec.phone1 + " " : '') + 
                                            (rec.phone2 ? rec.phone2 + " " : '') + (rec.phone3 ? rec.phone3 : '')

                                            if(rec.custName){
                                                app.custName = rec.custName
                                                app.custTel = rec.custTel
                                                app.custAddress = rec.custAddress
                                                this.showCust = true
                                            }
                                            else{
                                                this.showCust = false
                                            }
                                            if(rec.typePayment != null){
                                                let getTypePayment = []
                                                axios.post(this.webPath+'deliveryWebService.asmx/GetPayment', {
                                                    typePayment: rec.typePayment
                                                })
                                                .then(res=>{
                                                    getTypePayment = JSON.parse(res.data.d)
                                                    getTypePayment.forEach(payMent=>{
                                                        app.payMent = payMent.payment
                                                    })
                                                })
                                            }
                                            if(rec.transferAmt){
                                                app.transferAmt = rec.transferAmt
                                            }
                                            app.city = rec.city
                                            if(rec.serviceTime && rec.serviceTime.length == 13){
                                                let splitTime = rec.serviceTime.split("-")
                                                app.startTime = splitTime[0].substr(0,5)
                                                app.endTime = splitTime[1].substr(1,6)
                                            }
                                        })

                                        app.docEntryRT = result[0].docEntry
                                        app.getProdListRt(result[0].docEntry)
                                    }
                                })
                            }
                        })
                    }
                }
            }
        },

        // แสดงรายการสินค้าจาก RT
        getProdListRt(docEntryRT){
            this.prodListRt = []
            let app = this
            axios.post(app.webPath+'deliveryWebService.asmx/GetRtProdList', {
                docEntry: docEntryRT
            })
            .then(response=> {
                app.prodListRt = JSON.parse(response.data.d)
                app.prodListRt.forEach(rec=>{
                    rec.rtNo = app.rtNo
                    if(rec.poNo){
                        app.poNo = rec.poNo
                    }
                })
            })
            .then(()=>{
                app.showNewSo = true
            })
            .catch(()=> {
                app.searchSo = ''
                app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : GetRtProdList() has error"
                app.showDialogError = true
            })
        },

        // แสดงข้อความก่อนยืนยันการเปลี่ยนแปลงชื่อคนขับรถ, ทะเบียนรถ, เวลา SO
        showUpSO(){
            let time = null
            if(this.editTimeSt && this.editTimeEnd){
                time = this.editTimeSt + " - " + this.editTimeEnd
                this.msgWarning = "ยืนยันการเปลี่ยนคนขับ " + this.driver + " ทะเบียนรถ " + this.regNum + " เวลา " + time + " หรือไม่ ?"
                this.showWarningUpSO = true
            }
            else{
                this.msgWarning = "ยืนยันการเปลี่ยนคนขับ " + this.driver + " ทะเบียนรถ " + this.regNum + " หรือไม่ ?"
                this.showWarningUpSO = true
            }
        },

        // แสดงข้อความก่อนยืนยันการเปลี่ยนแปลงชื่อคนขับรถ, ทะเบียนรถ, เวลา RT
        showUpRT(){
            let time = null
            if(this.editTimeSt && this.editTimeEnd){
                time = this.editTimeSt + " - " + this.editTimeEnd
                this.msgWarning = "ยืนยันการเปลี่ยนคนขับ " + this.driver + " ทะเบียนรถ " + this.regNum + " เวลา " + time + " หรือไม่ ?"
                this.showWarningUpRT = true
            }
            else{
                this.msgWarning = "ยืนยันการเปลี่ยนคนขับ " + this.driver + " ทะเบียนรถ " + this.regNum + " หรือไม่ ?"
                this.showWarningUpRT = true
            }
        },

        // ยืนยันการเปลี่ยนแปลงชื่อคนขับรถ, ทะเบียนรถ, เวลา SO
        confiUpdateSO(){
            let app = this
            app.showWarningUpSO = false
            app.showDialogProgress = true
            let time = null
            if(this.editTimeSt && this.editTimeEnd){
                time = this.editTimeSt + " - " + this.editTimeEnd
            }
            if(this.editTimeSt && this.editTimeEnd){
                if(this.editTimeSt.length != 5 || this.editTimeEnd.length != 5){
                    this.showDialogProgress = false
                    this.msgError = "โปรดระบุเวลาตามรูปแบบที่กำหนด 00:00"
                    this.showDialogError = true
                }
                else{
                    let splitDriver = app.driver.split(" - ")
                    db.collection("deliveryList").doc(app.editId).update({
                        transNo: app.transNo.toString(),
                        time: time,
                        timeUpdate: time,
                        driver: app.driver,
                        driverName: splitDriver[1],
                        regNum: app.regNum,
                        loadDate: app.loadDate,
                        deliveryDate: app.deliDate,
                        updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                        updateBy: sessionStorage.user
                    })
                    .then(()=>{
                        db.collection("deliveryTimeline").doc(app.editIdTimeline).update({
                            date: app.deliDate,
                            driverName: splitDriver[1],
                            regNum: app.regNum,
                            timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}]
                        })
                        .then(()=>{
                            axios.post(app.webPath+'deliveryWebService.asmx/ChangeSO', {
                                docNum: app.editSoNo,
                                transNo: app.transNo,
                                loadDate: app.loadDate,
                                delDate: app.deliDate,
                                driver: splitDriver[0],
                                regNum: app.regNum,
                                serviceTime: time
                            })
                            .then(()=>{
                                if(app.editRtNo){
                                    axios.post(app.webPath+'deliveryWebService.asmx/ChangeRT', {
                                        docNum: app.editRtNo,
                                        transNo: app.transNo,
                                        loadDate: app.loadDate,
                                        delDate: app.deliDate,
                                        driver: splitDriver[0],
                                        regNum: app.regNum,
                                        serviceTime: time
                                    })
                                    .then(()=>{
                                        app.showDialogProgress = false
                                        app.showDialogSuccess = true
                                        setTimeout(() => {
                                            app.soList.push({ soNo: app.searchSo })
                                            app.showDialogSuccess = false
                                            app.cancelUpdate()
                                        }, 2000)
                                    })
                                    .catch(()=>{
                                        this.showDialogProgress = false
                                        this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : ChangeRT() has error"
                                        this.showDialogError = true
                                    })
                                }
                                else{
                                    app.showDialogProgress = false
                                    app.showDialogSuccess = true
                                    setTimeout(() => {
                                        app.soList.push({ soNo: app.soNo })
                                        app.showDialogSuccess = false
                                        app.cancelUpdate()
                                    }, 2000)
                                }
                            })
                            .catch(()=>{
                                this.showDialogProgress = false
                                this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : ChangeSO() has error"
                                this.showDialogError = true
                            })
                        })
                        .catch(()=>{
                            this.showDialogProgress = false
                            this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiUpdateSO(deliveryTimeline) has error"
                            this.showDialogError = true
                        })
                    })
                    .catch(()=>{
                        this.showDialogProgress = false
                        this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiUpdateSO(deliveryList) has error"
                        this.showDialogError = true
                    })
                }
            }
            else{
                let splitDriver = app.driver.split(" - ")
                db.collection("deliveryList").doc(app.editId).update({
                    transNo: app.transNo.toString(),
                    time: time,
                    timeUpdate: time,
                    driver: app.driver,
                    driverName: splitDriver[1],
                    regNum: app.regNum,
                    loadDate: app.loadDate,
                    deliveryDate: app.deliDate,
                    updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                    updateBy: sessionStorage.user
                })
                .then(()=>{
                    db.collection("deliveryTimeline").doc(app.editIdTimeline).update({
                        date: app.deliDate,
                        driverName: splitDriver[1],
                        regNum: app.regNum,
                        timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}]
                    })
                    .then(()=>{
                        axios.post(app.webPath+'deliveryWebService.asmx/ChangeSO', {
                            docNum: app.editSoNo,
                            transNo: app.transNo,
                            loadDate: app.loadDate,
                            delDate: app.deliDate,
                            driver: splitDriver[0],
                            regNum: app.regNum,
                            serviceTime: time
                        })
                        .then(()=>{
                            if(app.editRtNo){
                                axios.post(app.webPath+'deliveryWebService.asmx/ChangeRT', {
                                    docNum: app.editRtNo,
                                    transNo: app.transNo,
                                    loadDate: app.loadDate,
                                    delDate: app.deliDate,
                                    driver: splitDriver[0],
                                    regNum: app.regNum,
                                    serviceTime: time
                                })
                                .then(()=>{
                                    app.showDialogProgress = false
                                    app.showDialogSuccess = true
                                    setTimeout(() => {
                                        app.soList.push({ soNo: app.searchSo })
                                        app.showDialogSuccess = false
                                        app.cancelUpdate()
                                    }, 2000)
                                })
                                .catch(()=>{
                                    this.showDialogProgress = false
                                    this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : ChangeRT() has error"
                                    this.showDialogError = true
                                })
                            }
                            else{
                                app.showDialogProgress = false
                                app.showDialogSuccess = true
                                setTimeout(() => {
                                    app.soList.push({ soNo: app.soNo })
                                    app.showDialogSuccess = false
                                    app.cancelUpdate()
                                }, 2000)
                            }
                        })
                        .catch(()=>{
                            this.showDialogProgress = false
                            this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : ChangeSO() has error"
                            this.showDialogError = true
                        })
                    })
                    .catch(()=>{
                        this.showDialogProgress = false
                        this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiUpdateSO(deliveryTimeline) has error"
                        this.showDialogError = true
                    })
                })
                .catch(()=>{
                    this.showDialogProgress = false
                    this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiUpdateSO(deliveryList) has error"
                    this.showDialogError = true
                })
            }
        },

        // ยืนยันการเปลี่ยนแปลงชื่อคนขับรถ, ทะเบียนรถ, เวลา RT
        confiUpdateRT(){
            let app = this
            app.showWarningUpRT = false
            app.showDialogProgress = true
            let time = null
            if(this.editTimeSt && this.editTimeEnd){
                time = this.editTimeSt + " - " + this.editTimeEnd
            }
            if(this.editTimeSt && this.editTimeEnd){
                if(this.editTimeSt.length != 5 || this.editTimeEnd.length != 5){
                    this.showDialogProgress = false
                    this.msgError = "โปรดระบุเวลาตามรูปแบบที่กำหนด 00:00"
                    this.showDialogError = true
                }
                else{
                    let splitDriver = app.driver.split(" - ")
                    db.collection("deliveryList").doc(app.editId).update({
                        transNo: app.transNo.toString(),
                        time: time,
                        timeUpdate: time,
                        driver: app.driver,
                        driverName: splitDriver[1],
                        regNum: app.regNum,
                        loadDate: app.loadDate,
                        deliveryDate: app.deliDate,
                        updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                        updateBy: sessionStorage.user
                    })
                    .then(()=>{
                        db.collection("deliveryTimeline").doc(app.editIdTimeline).update({
                            date: app.deliDate,
                            driverName: splitDriver[1],
                            regNum: app.regNum,
                            timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}]
                        })
                        .then(()=>{
                            axios.post(app.webPath+'deliveryWebService.asmx/ChangeRT', {
                                docNum: app.editRtNo,
                                transNo: app.transNo,
                                loadDate: app.loadDate,
                                delDate: app.deliDate,
                                driver: splitDriver[0],
                                regNum: app.regNum,
                                serviceTime: time
                            })
                            .then(()=>{
                                app.showDialogProgress = false
                                app.showDialogSuccess = true
                                setTimeout(() => {
                                    app.rtList.push({ rtNo: app.searchRT })
                                    app.showDialogSuccess = false
                                    app.cancelUpdate()
                                }, 2000)
                            })
                            .catch(()=>{
                                this.showDialogProgress = false
                                this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : ChangeRT() has error"
                                this.showDialogError = true
                            })
                        })
                        .catch(()=>{
                            this.showDialogProgress = false
                            this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiUpdateSO(deliveryTimeline) has error"
                            this.showDialogError = true
                        })
                    })
                    .catch(()=>{
                        this.showDialogProgress = false
                        this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiUpdateSO(deliveryList) has error"
                        this.showDialogError = true
                    })
                }
            }
            else{
                let splitDriver = app.driver.split(" - ")
                db.collection("deliveryList").doc(app.editId).update({
                    transNo: app.transNo.toString(),
                    time: time,
                    timeUpdate: time,
                    driver: app.driver,
                    driverName: splitDriver[1],
                    regNum: app.regNum,
                    loadDate: app.loadDate,
                    deliveryDate: app.deliDate,
                    updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                    updateBy: sessionStorage.user
                })
                .then(()=>{
                    db.collection("deliveryTimeline").doc(app.editIdTimeline).update({
                        date: app.deliDate,
                        driverName: splitDriver[1],
                        regNum: app.regNum,
                        timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}]
                    })
                    .then(()=>{
                        axios.post(app.webPath+'deliveryWebService.asmx/ChangeRT', {
                            docNum: app.editRtNo,
                            transNo: app.transNo,
                            loadDate: app.loadDate,
                            delDate: app.deliDate,
                            driver: splitDriver[0],
                            regNum: app.regNum,
                            serviceTime: time
                        })
                        .then(()=>{
                            app.showDialogProgress = false
                            app.showDialogSuccess = true
                            setTimeout(() => {
                                app.rtList.push({ rtNo: app.searchRT })
                                app.showDialogSuccess = false
                                app.cancelUpdate()
                            }, 2000)
                        })
                        .catch(()=>{
                            this.showDialogProgress = false
                            this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : ChangeRT() has error"
                            this.showDialogError = true
                        })
                    })
                    .catch(()=>{
                        this.showDialogProgress = false
                        this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiUpdateSO(deliveryTimeline) has error"
                        this.showDialogError = true
                    })
                })
                .catch(()=>{
                    this.showDialogProgress = false
                    this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiUpdateSO(deliveryList) has error"
                    this.showDialogError = true
                })
            }
        },

        // ยกเลิกการเปลี่ยนแปลงชื่อคนขับรถ, ทะเบียนรถ, เวลา
        cancelUpdate(){
            this.searchSo = ''
            this.searchRT = ''
            this.editSoNo = ''
            this.editRtNo = ''
            this.editDriver = ''
            this.editRegNum = ''
            this.editTimeSt = ''
            this.editTimeEnd = ''
            this.editId = ''
            this.editIdTimeline = ''
            this.editCardCode = ''
            this.editCardName = ''
            this.editCustName = ''
            this.editProdList = []
            this.editProdListRt = []
            this.showUpdateSO = false
        },

        // เพิ่มข้อมูล SO ใหม่
        /**
         * Adds a new Sales Order (SO) to the delivery list.
         * 
         * This function performs the following steps:
         * 1. Validates the input for the start and end times.
         * 2. If the times are valid, it splits the driver's name to get the driver code and name.
         * 3. Updates the SO in the ORDR table with the new delivery details.
         * 4. If there are RT products, it updates the RT in the ORDN table with the new delivery details.
         * 5. Adds the new SO to the deliveryList collection in Firestore.
         * 6. Adds the new SO to the deliveryTimeline collection in Firestore.
         * 7. Displays a success dialog and resets the form.
         * 
         * @returns {void}
         */
        addSo(){
            let app = this
            let time = null
            if(app.startTime && app.endTime){
                time = app.startTime + " - " + app.endTime
            }
            if(app.startTime && app.startTime){
                if(app.startTime.length != 5 || app.startTime.length != 5){
                    app.showDialogProgress = false
                    app.msgError = "โปรดระบุเวลาตามรูปแบบที่กำหนด 00:00"
                    app.showDialogError = true
                }
                else{
                    let driverClone = app.driver
                    let driverSplit = driverClone.split(" - ")
                    app.showDialogProgress = true
                    // update SO in ORDR
                    axios.post(app.webPath+'deliveryWebService.asmx/UpdateSo', {
                        docEntry: app.docEntry,
                        transNo: app.transNo,
                        loadDate: app.loadDate,
                        delDate: app.deliDate,
                        driver: driverSplit[0],
                        regNum: app.regNum,
                        serviceTime: time
                    })
                    .then(()=>{
                        if(app.prodListRt.length > 0){
                            // update RT in ORDN
                            axios.post(app.webPath+'deliveryWebService.asmx/UpdateRT', {
                                docEntry: app.docEntryRT,
                                transNo: app.transNo,
                                loadDate: app.loadDate,
                                delDate: app.deliDate,
                                driver: driverSplit[0],
                                regNum: app.regNum,
                                serviceTime: time
                            })
                            .then(()=>{
                                db.collection("deliveryList").add({
                                    status: 'SO',
                                    transNo: app.transNo.toString(),
                                    loadDate: app.loadDate,
                                    regNum: app.regNum,
                                    driver: app.driver,
                                    driverName: driverSplit[1],
                                    deliveryDate: app.deliDate,
                                    cardCode: app.cardCode,
                                    cardPhone: app.cardPhone,
                                    cardName: app.cardName,
                                    custName: app.custName,
                                    custTel: app.custTel,
                                    time: time,
                                    custAddress: app.custAddress,
                                    // SAP's pin and landmark, so a job keyed here reaches the driver with them.
                                    geo: app.geo,
                                    landmark: app.landmark,
                                    prodList: app.prodList,
                                    prodListRt: app.prodListRt,
                                    soNo: app.soNo.toString(),
                                    rtNo: app.rtNo.toString(),
                                    city: app.city,
                                    payMent: app.payMent,
                                    timeStampStart: '',
                                    timeStampStartBy: '',
                                    timeStampEnd: '',
                                    timeStampEndBy: '',
                                    timeUpdate: time,
                                })
                                .then(()=>{
                                    db.collection("deliveryTimeline").add({
                                        trackNo: app.soNo.toString(),
                                        date: app.deliDate,
                                        timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}],
                                        driverName: driverSplit[1],
                                        regNum: app.regNum,
                                        status: 'Y',
                                        custTel: app.custTel,
                                        custName: app.custName,
                                    })
                                    .then(()=>{
                                        app.showDialogProgress = false
                                        app.showDialogSuccess = true
                                        setTimeout(() => {
                                            app.soList.push({ soNo: app.soNo })
                                            app.showDialogSuccess = false
                                            app.cancelAddSo()
                                        }, 2000)
                                    })
                                })
                            })
                            .catch(()=>{
                                app.showDialogProgress = false
                                app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : UpdateRT() has error"
                                app.showDialogError = true
                            })
                        }
                        else{
                            db.collection("deliveryList").add({
                                status: 'SO',
                                transNo: app.transNo.toString(),
                                loadDate: app.loadDate,
                                regNum: app.regNum,
                                driver: app.driver,
                                driverName: driverSplit[1],
                                deliveryDate: app.deliDate,
                                cardCode: app.cardCode,
                                cardPhone: app.cardPhone,
                                cardName: app.cardName,
                                custName: app.custName,
                                custTel: app.custTel,
                                time: time,
                                custAddress: app.custAddress,
                                // SAP's pin and landmark, so a job keyed here reaches the driver with them.
                                geo: app.geo,
                                landmark: app.landmark,
                                prodList: app.prodList,
                                prodListRt: app.prodListRt,
                                soNo: app.soNo.toString(),
                                city: app.city,
                                payMent: app.payMent,
                                transferAmt: app.transferAmt,
                                timeStampStart: '',
                                timeStampStartBy: '',
                                timeStampEnd: '',
                                timeStampEndBy: '',
                                timeUpdate: time,
                            })
                            .then(()=>{
                                db.collection("deliveryTimeline").add({
                                    trackNo: app.soNo.toString(),
                                    date: app.deliDate,
                                    timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}],
                                    driverName: driverSplit[1],
                                    regNum: app.regNum,
                                    status: 'Y',
                                    custTel: app.custTel,
                                    poNo: app.poNo,
                                    custName: app.custName,
                                })
                                .then(()=>{
                                    app.showDialogProgress = false
                                    app.showDialogSuccess = true
                                    setTimeout(() => {
                                        app.soList.push({ soNo: app.soNo, time: time })
                                        app.showDialogSuccess = false
                                        app.cancelAddSo()
                                    }, 2000)
                                })
                            })
                        }
                    })
                    .catch(()=>{
                        app.showDialogProgress = false
                        app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : UpdateSo() has error"
                        app.showDialogError = true
                    })
                }
            }
            else{
                let driverClone = app.driver
                let driverSplit = driverClone.split(" - ")
                app.showDialogProgress = true
                axios.post(app.webPath+'deliveryWebService.asmx/UpdateSo', {
                    docEntry: app.docEntry,
                    transNo: app.transNo,
                    loadDate: app.loadDate,
                    delDate: app.deliDate,
                    driver: driverSplit[0],
                    regNum: app.regNum,
                    serviceTime: time
                })
                .then(()=>{
                    if(app.prodListRt.length > 0){
                        axios.post(app.webPath+'deliveryWebService.asmx/UpdateRT', {
                            docEntry: app.docEntryRT,
                            transNo: app.transNo,
                            loadDate: app.loadDate,
                            delDate: app.deliDate,
                            driver: driverSplit[0],
                            regNum: app.regNum,
                            serviceTime: time
                        })
                        .then(()=>{
                            db.collection("deliveryList").add({
                                status: 'SO',
                                transNo: app.transNo.toString(),
                                loadDate: app.loadDate,
                                regNum: app.regNum,
                                driver: app.driver,
                                driverName: driverSplit[1],
                                deliveryDate: app.deliDate,
                                cardCode: app.cardCode,
                                cardPhone: app.cardPhone,
                                cardName: app.cardName,
                                custName: app.custName,
                                custTel: app.custTel,
                                time: time,
                                custAddress: app.custAddress,
                                // SAP's pin and landmark, so a job keyed here reaches the driver with them.
                                geo: app.geo,
                                landmark: app.landmark,
                                prodList: app.prodList,
                                prodListRt: app.prodListRt,
                                soNo: app.soNo.toString(),
                                rtNo: app.rtNo.toString(),
                                city: app.city,
                                payMent: app.payMent,
                                timeStampStart: '',
                                timeStampStartBy: '',
                                timeStampEnd: '',
                                timeStampEndBy: '',
                                timeUpdate: time,
                            })
                            .then(()=>{
                                db.collection("deliveryTimeline").add({
                                    trackNo: app.soNo.toString(),
                                    date: app.deliDate,
                                    timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}],
                                    driverName: driverSplit[1],
                                    regNum: app.regNum,
                                    status: 'Y',
                                    custTel: app.custTel,
                                    custName: app.custName,
                                })
                                .then(()=>{
                                    app.showDialogProgress = false
                                    app.showDialogSuccess = true
                                    setTimeout(() => {
                                        app.soList.push({ soNo: app.soNo })
                                        app.showDialogSuccess = false
                                        app.cancelAddSo()
                                    }, 2000)
                                })
                            })
                        })
                        .catch(()=>{
                            app.showDialogProgress = false
                            app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : UpdateRT() has error"
                            app.showDialogError = true
                        })
                    }
                    else{
                        db.collection("deliveryList").add({
                            status: 'SO',
                            transNo: app.transNo.toString(),
                            loadDate: app.loadDate,
                            regNum: app.regNum,
                            driver: app.driver,
                            driverName: driverSplit[1],
                            deliveryDate: app.deliDate,
                            cardCode: app.cardCode,
                            cardPhone: app.cardPhone,
                            cardName: app.cardName,
                            custName: app.custName,
                            custTel: app.custTel,
                            time: time,
                            custAddress: app.custAddress,
                            // SAP's pin and landmark, so a job keyed here reaches the driver with them.
                            geo: app.geo,
                            landmark: app.landmark,
                            prodList: app.prodList,
                            prodListRt: app.prodListRt,
                            soNo: app.soNo.toString(),
                            city: app.city,
                            payMent: app.payMent,
                            transferAmt: app.transferAmt,
                            timeStampStart: '',
                            timeStampStartBy: '',
                            timeStampEnd: '',
                            timeStampEndBy: '',
                            timeUpdate: time,
                        })
                        .then(()=>{
                            db.collection("deliveryTimeline").add({
                                trackNo: app.soNo.toString(),
                                date: app.deliDate,
                                timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}],
                                driverName: driverSplit[1],
                                regNum: app.regNum,
                                status: 'Y',
                                custTel: app.custTel,
                                poNo: app.poNo,
                                custName: app.custName,
                            })
                            .then(()=>{
                                app.showDialogProgress = false
                                app.showDialogSuccess = true
                                setTimeout(() => {
                                    app.soList.push({ soNo: app.soNo, time: time })
                                    app.showDialogSuccess = false
                                    app.cancelAddSo()
                                }, 2000)
                            })
                        })
                    }
                })
                .catch(()=>{
                    app.showDialogProgress = false
                    app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : UpdateSo() has error"
                    app.showDialogError = true
                })
            }
        },

        // เพิ่มข้อมูบ RT ใหม่
        addRt(){
            let app = this
            let time = null
            if(app.startTime && app.endTime){
                time = app.startTime + " - " + app.endTime
            }
            if(app.startTime && app.startTime){
                if(app.startTime.length != 5 || app.startTime.length != 5){
                    app.showDialogProgress = false
                    app.msgError = "โปรดระบุเวลาตามรูปแบบที่กำหนด 00:00"
                    app.showDialogError = true
                }
                else{
                    let driverClone = app.driver
                    let driverSplit = driverClone.split(" - ")
                    app.showDialogProgress = true
                    axios.post(app.webPath+'deliveryWebService.asmx/UpdateRT', {
                        docEntry: app.docEntryRT,
                        transNo: app.transNo,
                        loadDate: app.loadDate,
                        delDate: app.deliDate,
                        driver: driverSplit[0],
                        regNum: app.regNum,
                        serviceTime: time
                    })
                    .then(()=>{
                        db.collection("deliveryList").add({
                            status: 'RT',
                            transNo: app.transNo.toString(),
                            loadDate: app.loadDate,
                            regNum: app.regNum,
                            driver: app.driver,
                            driverName: driverSplit[1],
                            deliveryDate: app.deliDate,
                            cardCode: app.cardCode,
                            cardPhone: app.cardPhone,
                            cardName: app.cardName,
                            custName: app.custName,
                            custTel: app.custTel,
                            time: time,
                            custAddress: app.custAddress,
                            prodList: app.prodList,
                            prodListRt: app.prodListRt,
                            rtNo: app.rtNo.toString(),
                            city: app.city,
                            payMent: app.payMent,
                            transferAmt: app.transferAmt,
                            timeStampStart: '',
                            timeStampStartBy: '',
                            timeStampEnd: '',
                            timeStampEndBy: '',
                            timeUpdate: time,
                        })
                        .then(()=>{
                            db.collection("deliveryTimeline").add({
                                trackNo: app.rtNo.toString(),
                                date: app.deliDate,
                                timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}],
                                driverName: driverSplit[1],
                                regNum: app.regNum,
                                status: 'Y',
                                custTel: app.custTel,
                                poNo: app.poNo,
                                custName: app.custName,
                            })
                            .then(()=>{
                                app.showDialogProgress = false
                                app.showDialogSuccess = true
                                setTimeout(() => {
                                    app.rtList.push({ rtNo: app.rtNo, time: time })
                                    app.showDialogSuccess = false
                                    app.cancelAddSo()
                                }, 2000)
                            })
                        })
                    })
                    .catch(()=>{
                        app.showDialogProgress = false
                        app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : UpdateRT() has error"
                        app.showDialogError = true
                    })
                }
            }
            else{
                let driverClone = app.driver
                let driverSplit = driverClone.split(" - ")
                app.showDialogProgress = true
                axios.post(app.webPath+'deliveryWebService.asmx/UpdateRT', {
                    docEntry: app.docEntryRT,
                    transNo: app.transNo,
                    loadDate: app.loadDate,
                    delDate: app.deliDate,
                    driver: driverSplit[0],
                    regNum: app.regNum,
                    serviceTime: time
                })
                .then(()=>{
                    db.collection("deliveryList").add({
                        status: 'RT',
                        transNo: app.transNo.toString(),
                        loadDate: app.loadDate,
                        regNum: app.regNum,
                        driver: app.driver,
                        driverName: driverSplit[1],
                        deliveryDate: app.deliDate,
                        cardCode: app.cardCode,
                        cardPhone: app.cardPhone,
                        cardName: app.cardName,
                        custName: app.custName,
                        custTel: app.custTel,
                        time: time,
                        custAddress: app.custAddress,
                        prodList: app.prodList,
                        prodListRt: app.prodListRt,
                        rtNo: app.rtNo.toString(),
                        city: app.city,
                        payMent: app.payMent,
                        transferAmt: app.transferAmt,
                        timeStampStart: '',
                        timeStampStartBy: '',
                        timeStampEnd: '',
                        timeStampEndBy: '',
                        timeUpdate: time,
                    })
                    .then(()=>{
                        db.collection("deliveryTimeline").add({
                            trackNo: app.rtNo.toString(),
                            date: app.deliDate,
                            timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}],
                            driverName: driverSplit[1],
                            regNum: app.regNum,
                            status: 'Y',
                            custTel: app.custTel,
                            poNo: app.poNo,
                            custName: app.custName,
                        })
                        .then(()=>{
                            app.showDialogProgress = false
                            app.showDialogSuccess = true
                            setTimeout(() => {
                                app.rtList.push({ rtNo: app.rtNo, time: time })
                                app.showDialogSuccess = false
                                app.cancelAddSo()
                            }, 2000)
                        })
                    })
                })
                .catch(()=>{
                    app.showDialogProgress = false
                    app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : UpdateRT() has error"
                    app.showDialogError = true
                })
            }
        },

        // ยกเลิกการเพิ่มเลขที่ SO
        cancelAddSo(){
            this.rtNo = ''
            this.soNo = ''
            this.poNo = ''
            this.docEntryRT = ''
            this.cardCode = ''
            this.cardPhone = ''
            this.cardName = ''
            this.custName = ''
            this.custTel = ''
            this.startTime = ''
            this.endTime = ''
            this.custAddress = ''
            this.geo = ''
            this.landmark = ''
            this.city = ''
            this.payMent = ''
            this.transferAmt = ''
            this.showCust = false
            this.prodList = []
            this.prodListRt = []
            this.showNewSo = false
            if(this.searchSo){
                this.searchSo = ''
                this.$nextTick(()=>this.$refs.searchSo.focus())
            }
            if(this.searchRT){
                this.searchRT = ''
                this.$nextTick(()=>this.$refs.searchRT.focus())
            }
        },

        // This sheet's deliveryList row and its timeline for one SO / RT line. A
        // number delivered before (a rebooking, a second pickup) has a row and a
        // timeline per visit, and docs[0] of either could be another visit's --
        // which a delete would then remove. The row is the line's own (`id`) or
        // the one on this ใบจัดรถ; the timeline matches its date and plate
        // (deliveryRow.timelineFor). null for either when it cannot be told.
        async sheetVisit(field, item){
            const no = String(item[field])
            let row = null
            if (item.id) {
                const doc = await db.collection("deliveryList").doc(item.id).get()
                if (doc.exists) row = Object.assign({ id: doc.id }, doc.data())
            }
            if (!row) {
                const snap = await db.collection("deliveryList").where(field, "==", no).get()
                const rows = snap.docs.map(d => Object.assign({ id: d.id }, d.data()))
                const transNo = String(this.transNo || this.findNoManageCar || '')
                row = rows.find(r => transNo && String(r.transNo) === transNo) || (rows.length === 1 ? rows[0] : null)
            }
            if (!row) return { row: null, timeline: null }
            const snap = await db.collection("deliveryTimeline").where("trackNo", "==", no).get()
            const timeline = DR.timelineFor(snap.docs.map(d => Object.assign({ id: d.id }, d.data())), row)
            return { row, timeline }
        },
        sheetVisitError(where, no, error){
            if (error) reportError(where + ' could not read the sheet row', error)
            this.showDialogProgress = false
            this.msgError = error
                ? "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : " + where + " has error"
                : "หาเอกสารของเลขที่ " + no + " ในใบจัดรถนี้ไม่พบ (มีหลายรอบส่ง) โปรดติดต่อฝ่าย IT Kiosk"
            this.showDialogError = true
        },
        splitEditTime(time){
            const t = time ? String(time).split(" - ") : []
            this.editTimeSt = t[0] || ''
            this.editTimeEnd = t[1] || ''
        },

        // แก้ไข SO
        editSO(item){
            this.editId = ''
            this.editIdTimeline = ''
            this.soNo = item.soNo
            this.showDialogProgress = true
            this.sheetVisit('soNo', item)
            .then(({ row, timeline })=>{
                if (!row || !timeline) return this.sheetVisitError('editSO', item.soNo)
                this.editId = row.id
                this.editIdTimeline = timeline.id
                if (row.rtNo) this.rtNo = row.rtNo
                this.splitEditTime(row.time)
                this.editSoNo = item.soNo.toString()
                this.showDialogProgress = false
                this.showEditSO = true
                setTimeout(()=>{
                    this.$nextTick(()=>this.$refs.editTimeSt.focus())
                },1)
            })
            .catch(error=>this.sheetVisitError('editSO', item.soNo, error))
        },

        // ยืนยันการแก้ไข SO
        confiEditSO(){
            let app = this
            this.showDialogProgress = true
            let time = null
            if(this.editTimeSt && this.editTimeEnd){
                time = this.editTimeSt + " - " + this.editTimeEnd
            }
            if(this.editTimeSt && this.editTimeEnd){
                if(this.editTimeSt.length != 5 || this.editTimeEnd.length != 5){
                    this.showDialogProgress = false
                    this.msgError = "โปรดระบุเวลาตามรูปแบบที่กำหนด 00:00"
                    this.showDialogError = true
                }
                else{
                    db.collection("deliveryList").doc(app.editId).update({
                        time: time,
                        timeUpdate: time,
                        updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                        updateBy: sessionStorage.user
                    })
                    .then(()=>{
                        db.collection("deliveryTimeline").doc(app.editIdTimeline).update({
                        timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}]
                        })
                        .then(()=>{
                            axios.post(app.webPath+'deliveryWebService.asmx/editTimeSO', {
                                soNo: app.soNo,
                                serviceTime: time
                            })
                            .then(()=>{
                                if(app.rtNo){
                                    axios.post(app.webPath+'deliveryWebService.asmx/editTimeRT', {
                                        rtNo: app.rtNo,
                                        serviceTime: time
                                    })
                                    .then(()=>{
                                        app.showDialogProgress = false
                                        app.showDialogSuccess = true
                                        setTimeout(()=>{
                                            app.cancelEdit()
                                            app.showDialogSuccess = false
                                        },2000)
                                    })
                                    .catch(()=>{
                                        app.showDialogProgress = false
                                        app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : editTimeSO() has error"
                                        app.showDialogError = true
                                    })
                                }
                                else{
                                    app.showDialogProgress = false
                                    app.showDialogSuccess = true
                                    setTimeout(()=>{
                                        let index = app.soList.findIndex(i=>i.soNo == app.soNo)
                                        app.soList[index].time = time
                                        app.cancelEdit()
                                        app.showDialogSuccess = false
                                    },2000)
                                }
                            })
                            .catch(()=>{
                                app.showDialogProgress = false
                                app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : editTimeSO() has error"
                                app.showDialogError = true
                            })
                        })
                    })
                }
            }
            else{
                db.collection("deliveryList").doc(app.editId).update({
                    time: time,
                    timeUpdate: time,
                    updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                    updateBy: sessionStorage.user
                })
                .then(()=>{
                    db.collection("deliveryTimeline").doc(app.editIdTimeline).update({
                    timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}]
                    })
                    .then(()=>{
                        axios.post(app.webPath+'deliveryWebService.asmx/editTimeSO', {
                            soNo: app.soNo,
                            serviceTime: time
                        })
                        .then(()=>{
                            if(app.rtNo){
                                axios.post(app.webPath+'deliveryWebService.asmx/editTimeRT', {
                                    rtNo: app.rtNo,
                                    serviceTime: time
                                })
                                .then(()=>{
                                    app.showDialogProgress = false
                                    app.showDialogSuccess = true
                                    setTimeout(()=>{
                                        app.cancelEdit()
                                        app.showDialogSuccess = false
                                    },2000)
                                })
                                .catch(()=>{
                                    app.showDialogProgress = false
                                    app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : editTimeSO() has error"
                                    app.showDialogError = true
                                })
                            }
                            else{
                                app.showDialogProgress = false
                                app.showDialogSuccess = true
                                setTimeout(()=>{
                                    let index = app.soList.findIndex(i=>i.soNo == app.soNo)
                                    app.soList[index].time = time
                                    app.cancelEdit()
                                    app.showDialogSuccess = false
                                },2000)
                            }
                        })
                        .catch(()=>{
                            app.showDialogProgress = false
                            app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : editTimeSO() has error"
                            app.showDialogError = true
                        })
                    })
                })
            }
        },

        // แก้ไข RT
        editRT(item){
            this.editId = ''
            this.editIdTimeline = ''
            this.rtNo = item.rtNo
            this.showDialogProgress = true
            this.sheetVisit('rtNo', item)
            .then(({ row, timeline })=>{
                if (!row || !timeline) return this.sheetVisitError('editRT', item.rtNo)
                this.editId = row.id
                this.editIdTimeline = timeline.id
                this.splitEditTime(row.time)
                this.editRtNo = item.rtNo.toString()
                this.showDialogProgress = false
                this.showEditRT = true
                setTimeout(()=>{
                    this.$nextTick(()=>this.$refs.editTimeSt.focus())
                },1)
            })
            .catch(error=>this.sheetVisitError('editRT', item.rtNo, error))
        },

        // ยืนยันการแก้ไข RT
        confiEditRT(){
            let app = this
            this.showDialogProgress = true
            let time = null
            if(this.editTimeSt && this.editTimeEnd){
                time = this.editTimeSt + " - " + this.editTimeEnd
            }
            if(this.editTimeSt && this.editTimeEnd){
                if(this.editTimeSt.length != 5 || this.editTimeEnd.length != 5){
                    this.showDialogProgress = false
                    this.msgError = "โปรดระบุเวลาตามรูปแบบที่กำหนด 00:00"
                    this.showDialogError = true
                }
                else{
                    db.collection("deliveryList").doc(app.editId).update({
                        time: time,
                        timeUpdate: time,
                        updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                        updateBy: sessionStorage.user
                    })
                    .then(()=>{
                        db.collection("deliveryTimeline").doc(app.editIdTimeline).update({
                        timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}]
                        })
                        .then(()=>{
                            axios.post(app.webPath+'deliveryWebService.asmx/editTimeRT', {
                                rtNo: app.rtNo,
                                serviceTime: time
                            })
                            .then(()=>{
                                app.showDialogProgress = false
                                app.showDialogSuccess = true
                                setTimeout(()=>{
                                    let index = app.rtList.findIndex(i=>i.rtNo == app.rtNo)
                                    app.rtList[index].time = time
                                    app.cancelEdit()
                                    app.showDialogSuccess = false
                                },2000)
                            })
                            .catch(()=>{
                                app.showDialogProgress = false
                                app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : editTimeSO() has error"
                                app.showDialogError = true
                            })
                        })
                    })
                }
            }
            else{
                db.collection("deliveryList").doc(app.editId).update({
                    time: time,
                    timeUpdate: time,
                    updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                    updateBy: sessionStorage.user
                })
                .then(()=>{
                    db.collection("deliveryTimeline").doc(app.editIdTimeline).update({
                    timeLine: [{ time: time, desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline"}]
                    })
                    .then(()=>{
                        axios.post(app.webPath+'deliveryWebService.asmx/editTimeRT', {
                            rtNo: app.rtNo,
                            serviceTime: time
                        })
                        .then(()=>{
                            app.showDialogProgress = false
                            app.showDialogSuccess = true
                            setTimeout(()=>{
                                let index = app.rtList.findIndex(i=>i.rtNo == app.rtNo)
                                app.rtList[index].time = time
                                app.cancelEdit()
                                app.showDialogSuccess = false
                            },2000)
                        })
                        .catch(()=>{
                            app.showDialogProgress = false
                            app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : editTimeSO() has error"
                            app.showDialogError = true
                        })
                    })
                })
            }
        },

        // ยกเลิกการแก้ไข SO
        cancelEdit(){
            this.soNo = ''
            this.rtNo = ''
            this.editTimeSt = ''
            this.editTimeEnd = ''
            this.showEditSO = false
            this.showEditRT = false
        },

        // ลบเลขที่ SO ออกจากการจัดรถ
        delSo(item){
            this.showDialogProgress = true
            this.soNo = item.soNo
            this.msgWarning = "ต้องการลบเลขที่ " + this.soNo + " หรือไม่ ?"
            this.sheetVisit('soNo', item)
            .then(({ row, timeline })=>{
                if (!row || !timeline) return this.sheetVisitError('delSo', item.soNo)
                this.idSo = row.id
                this.idTrack = timeline.id
                return this.loadDelGuard(this.idSo)
                .then(()=>{
                    this.showDialogProgress = false
                    this.showWarning = true
                })
            })
            .catch(error=>this.sheetVisitError('delSo', item.soNo, error))
        },

        // ยืนยันการลบเลขที่ SO ที่เลือก
        confiDel(){
            let app = this
            app.showDialogProgress = true
            db.collection("deliveryList").doc(app.idSo).delete()
            .then(()=>{
                db.collection("deliveryTimeline").doc(app.idTrack).delete()
                .then(()=>{
                    axios.post(app.webPath+'deliveryWebService.asmx/CancelSo', {
                        soNo: app.soNo
                    })
                    .then(()=>{
                        app.showDialogProgress = false
                        app.showDelSuccess = true
                        setTimeout(() => {
                            app.soList.splice(app.soList.findIndex(prod=>prod.soNo==app.soNo),1)
                            if(app.findNoManageCar){
                                app.arrSO.splice(app.arrSO.findIndex(prod=>prod.soNo==app.soNo),1)
                                if(app.arrSO.length == 0){
                                    app.closeFind()
                                }
                            }
                            if(this.soList.length == 0){
                                app.searchData = false
                                app.noData = true
                            }
                            app.showWarning = false
                            app.showDelSuccess = false
                        }, 1000)
                    })
                    .catch(()=>{
                        app.showDialogProgress = false
                        app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : CancelSo() has error"
                        app.showDialogError = true
                    })
                })
            })
        },

        // ลบเลขที่ RT ออกจากการจัดรถ
        delRt(item){
            this.showDialogProgress = true
            this.rtNo = item.rtNo
            this.msgWarningRT = "ต้องการลบเลขที่ " + this.rtNo + " หรือไม่ ?"
            this.sheetVisit('rtNo', item)
            .then(({ row, timeline })=>{
                if (!row || !timeline) return this.sheetVisitError('delRt', item.rtNo)
                this.idRt = row.id
                this.idTrack = timeline.id
                return this.loadDelGuard(this.idRt)
                .then(()=>{
                    this.showDialogProgress = false
                    this.showWarningRT = true
                })
            })
            .catch(error=>this.sheetVisitError('delRt', item.rtNo, error))
        },

        // ยืนยันการลบเลขที่ RT ที่เลือก
        confiDelRt(){
            let app = this
            app.showDialogProgress = true
            db.collection("deliveryList").doc(app.idRt).delete()
            .then(()=>{
                db.collection("deliveryTimeline").doc(app.idTrack).delete()
                .then(()=>{
                    axios.post(app.webPath+'deliveryWebService.asmx/CancelRt', {
                        rtNo: app.rtNo
                    })
                    .then(()=>{
                        app.showDialogProgress = false
                        app.showDelSuccess = true
                        setTimeout(() => {
                            app.rtList.splice(app.rtList.findIndex(prod=>prod.rtNo==app.rtNo),1)
                            if(app.findNoManageCar){
                                app.arrRT.splice(app.arrRT.findIndex(prod=>prod.rtNo==app.rtNo),1)
                                if(app.arrRT.length == 0){
                                    app.closeFind()
                                }
                            }
                            if(this.rtList.length == 0){
                                app.searchData = false
                                app.noData = true
                            }
                            app.showWarningRT = false
                            app.showDelSuccess = false
                        }, 1000)
                    })
                    .catch(()=>{
                        app.showDialogProgress = false
                        app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : CancelRt() has error"
                        app.showDialogError = true
                    })
                })
            })
        },

        // พิมพ์ใบจัดส่งสินค้า
        printDelivery(){
            if(this.findNoManageCar){
                let routeData = this.$router.resolve({name: 'deliveryReport', query: {
                    transNo: this.findNoManageCar.toString()
                }})
                window.open(routeData.href, "_blank")
            }
            else{
                let routeData = this.$router.resolve({name: 'deliveryReport', query: {
                    transNo: this.transNo.toString()
                }})
                window.open(routeData.href, "_blank")
            }
        },

        // แสดงหน้าค้นหาเลขที่ใบจัดรถ
        showDialogFindManageCar(){
            this.dialogFindManageCar = true
            setTimeout(()=>{
                this.$nextTick(()=>this.$refs.findNoManageCar.focus())
            },1)
        },

        // แสดงหน้าค้นหาเลขที่ SO
        showDialogFindSO(){
            this.dialogFindSO = true
            setTimeout(()=>{
                this.$nextTick(()=>this.$refs.findNoSO.focus())
            },1)
        },

        // แสดงหน้าค้นหาเลขที่ SO
        showDialogFindRT(){
            this.dialogFindRT = true
            setTimeout(()=>{
                this.$nextTick(()=>this.$refs.findNoRT.focus())
            },1)
        }
    },
    watch:{
        // Any load, add or delete of an SO or RT re-reads the sheet for the
        // พิกัด and รายการสินค้า columns.
        // An opened row that left the list (cleared, deleted) is dropped, so
        // ขยายทั้งหมด / ย่อทั้งหมด reads true.
        soList(list){
            this.expandedSo = this.expandedSo.filter(e => list.some(i => i.soNo === e.soNo))
            this.loadSheetPins()
        },
        rtList(list){
            this.expandedRt = this.expandedRt.filter(e => list.some(i => i.rtNo === e.rtNo))
            this.loadSheetPins()
        }
    },
    computed:{
        webPath(){
            return this.$store.getters.webPath
        },
        // The two tables' lines: customer and plan day from the sheet's rows, in
        // plan order on a planned trip, else by เวลาส่ง (deliveryRow.sheetLines).
        soLines(){
            return DR.sheetLines(this.soList, item => this.sheetRowForSo(item))
        },
        rtLines(){
            return DR.sheetLines(this.rtList, item => this.sheetRowForRt(item))
        },
        // วันส่ง only on a sheet that carries a plan; any other sheet keeps its columns.
        soHeaderShown(){
            return this.soLines.some(l => l.planDay) ? this.soHeader : this.soHeader.filter(h => h.value !== 'planDay')
        },
        rtHeaderShown(){
            return this.rtLines.some(l => l.planDay) ? this.rtHeader : this.rtHeader.filter(h => h.value !== 'planDay')
        },
        // SOs on this sheet whose job has no readable pin, for the count above the table.
        sheetPinMissing(){
            return this.soList.filter(item => !this.hasPin(item)).length
        },
        // The extra line the four delete dialogs show, or '' for a job no
        // driver has touched.
        delGuardNote(){
            return driverDay.deleteGuardNote(this.delGuard)
        },
        // A job the driver already FINISHED is the case worth colouring: the
        // delivery happened, and deleting the row destroys the only record of
        // it. Everything else stays the warning yellow it has always been.
        delGuardColor(){
            return this.delGuard.finished ? 'red' : 'yellow accent-4'
        },
        delGuardOkColor(){
            return this.delGuard.finished ? 'red' : 'green'
        },
        delGuardTextClass(){
            return this.delGuard.finished ? 'red--text font-weight-bold' : 'orange--text text--darken-3'
        },
        // คำนวณผลรวมปริมาตรทั้งหมด SO
        totalVolume(){
            return this.prodList.reduce((total,rec)=> total+(rec.volume),0)
        },
    },
    mounted(){
        this.getDriver()
        this.getRegNum()
        this.$nextTick(()=>this.$refs.transNo.focus())
        // this.getTransNolast()
        if(this.$route.query.transNo){
            let app = this
            this.transNo = this.$route.query.transNo
            this.searchData = true
            this.noData = false
            db.collection("deliveryList").where("transNo", "==", this.transNo).get()
            .then(query=>{
                this.soList = []
                this.rtList = []
                let i = 0
                query.forEach(doc=>{
                    if(doc.data().soNo){
                        app.soList.push({ soNo: doc.data().soNo, rtNo: doc.data().rtNo, 
                        id: query.docs[i].id, time: doc.data().time })
                    }
                    else{
                        app.rtList.push({ rtNo: doc.data().rtNo, 
                        id: query.docs[i].id, time: doc.data().time })
                    }
                    i++
                })
                if(this.soList.length == 0){
                    this.searchData = false
                    this.noData = true
                }
                if(this.rtList.length == 0){
                    this.searchData = false
                    this.noData = true
                }
            })
        }
        if(this.$route.query.loadDate){
            this.loadDate = this.$route.query.loadDate
        }
        if(this.$route.query.delDate){
            this.deliDate = this.$route.query.delDate
        }
        if(this.$route.query.regNum){
            this.regNum = this.$route.query.regNum
        }
        
    }
}
</script><style scoped>
/* ลูกค้า column: the whole address, wrapped -- delivery checks it against the plan. */
.sheet-cust { max-width: 420px; }
.sheet-cust-addr { white-space: normal; line-height: 1.3; }
</style>
